webpackJsonp([1],{

/***/ "/Muf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/RZT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4GY5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "809j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aw40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C0Js":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EFfJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iyms":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KxB8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NALb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.js
var marked = __webpack_require__("EFqf");
var marked_default = /*#__PURE__*/__webpack_require__.n(marked);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LogoSquare.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LogoSquare = ({
  name: 'logoSquare',
  props: ['light']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3ae5334","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoSquare.vue
var LogoSquare_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"64","height":"48","version":"1.1","viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg","xmlns:cc":"http://creativecommons.org/ns#","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:rdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M17.572 23.933l4.106 7.095L32 13.189h-8.981V7.582L11.51.972 0 7.582v13.222l11.51 6.611 6.062-3.482zm10.96-8.744l-6.855 11.846-6.855-11.846h13.71z","fill":"#ffffff"}})])])])}
var staticRenderFns = []
var esExports = { render: LogoSquare_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_LogoSquare = (esExports);
// CONCATENATED MODULE: ./src/components/LogoSquare.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LogoSquare,
  components_LogoSquare,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_LogoSquare = (Component.exports);

// EXTERNAL MODULE: ./node_modules/semver/semver.js
var semver = __webpack_require__("6S2P");
var semver_default = /*#__PURE__*/__webpack_require__.n(semver);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/data/DocsSource.js








var json = function json(res) {
  if (!res.ok) throw new Error('Failed to fetch github data');
  return res.json();
};

var DocsSource_DocsSource = function () {
  function DocsSource(options) {
    classCallCheck_default()(this, DocsSource);

    this.id = options.id;
    this.name = options.name;
    this.global = options.global;
    this.repo = options.repo;
    this.defaultTag = options.defaultTag || 'master';
    this.defaultClass = options.defaultClass;
    this.defaultFile = options.defaultFile || { category: 'general', id: 'welcome' };
    this.source = options.source || 'https://github.com/' + this.repo + '/blob/';
    this.branchFilter = options.branchFilter;
    this.tagFilter = options.tagFilter || function () {
      return true;
    };
    this.tags = null;
    this.recentTag = null;
  }

  createClass_default()(DocsSource, [{
    key: 'fetchTags',
    value: function fetchTags() {
      var _this = this;

      if (this.tags) return promise_default.a.resolve(this.tags);
      return promise_default.a.all([fetch('https://api.github.com/repos/' + this.repo + '/branches').then(json), fetch('https://api.github.com/repos/' + this.repo + '/tags').then(json)]).catch(function (err) {
        if (localStorage['source-' + _this.id]) {
          console.error(err);
          var cache = JSON.parse(localStorage['source-' + _this.id]);
          return [cache.branches, cache.tags];
        }
        throw err;
      }).then(function (data) {
        var _data = slicedToArray_default()(data, 2),
            branches = _data[0],
            tags = _data[1];

        _this.tags = [_this.defaultTag];
        localStorage['source-' + _this.id] = stringify_default()({ branches: branches, tags: tags });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(branches), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var branch = _step.value;

            if (branch.name !== _this.defaultTag && _this.branchFilter(branch.name)) _this.tags.push(branch.name);
          }

          // Build a list of the latest patch versions
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var latestPatches = {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(tags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tag = _step2.value;

            if (semver_default.a.valid(tag.name)) {
              var majorMinor = semver_default.a.major(tag.name) + '.' + semver_default.a.minor(tag.name);
              var patch = semver_default.a.patch(tag.name);
              if (patch < latestPatches[majorMinor]) continue;
              latestPatches[majorMinor] = patch;
            }
          }

          // Build the list of tags
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(tags), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _tag = _step3.value;

            if (_tag.name === _this.defaultTag) continue;
            if (!_this.tagFilter(_tag.name)) continue;

            // Make sure the tag is the latest patch version
            if (semver_default.a.valid(_tag.name)) {
              var _majorMinor = semver_default.a.major(_tag.name) + '.' + semver_default.a.minor(_tag.name);
              var _patch = semver_default.a.patch(_tag.name);
              if (_patch < latestPatches[_majorMinor]) continue;
            }

            _this.tags.push(_tag.name);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return _this.tags;
      });
    }
  }, {
    key: 'fetchDocs',
    value: function fetchDocs(tag) {
      // eslint-disable-next-line no-unused-vars
      // return new Promise((resolve, reject) => {
      //  resolve(require(`H:/JavaScript/hypixel-api-reborn-project/hypixel-api-reborn/${tag}.json`));
      // });
      // eslint-disable-next-line capitalized-comments
      return fetch('https://raw.githubusercontent.com/' + this.repo + '/docs/' + tag + '.json').then(json);
    }
  }]);

  return DocsSource;
}();

/* harmony default export */ var data_DocsSource = (DocsSource_DocsSource);
// CONCATENATED MODULE: ./src/data/MainSource.js



var branchBlacklist = ['docs'];
/* harmony default export */ var MainSource = (new data_DocsSource({
  id: 'main',
  name: 'Main library',
  global: 'Hypixel',
  repo: 'hypixel-api-reborn/hypixel-api-reborn',
  defaultTag: 'master',
  defaultClass: 'Client',
  branchFilter: function branchFilter(branch) {
    return !branchBlacklist.includes(branch) && !branch.startsWith('dependabot/');
  },
  tagFilter: function tagFilter(tag) {
    return semver_default.a.gte(tag, '6.0.0');
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppNavbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AppNavbar = ({
  name: 'navbar',
  props: ['repository'],
  components: {
    LogoSquare: src_components_LogoSquare
  },
  data: function data() {
    return {
      docs: {
        class: MainSource.defaultClass
      },
      tutorials: {
        category: MainSource.defaultFile.category,
        file: MainSource.defaultFile.id
      }
    };
  },

  computed: {
    tag: function tag() {
      return this.$route.params.tag || MainSource.defaultTag;
    },
    source: function source() {
      return this.$route.params.source || MainSource.id;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f4a8b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNavbar.vue
var AppNavbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('container',[_c('router-link',{attrs:{"to":"/"}},[_c('logoSquare',{attrs:{"id":"logo"}})],1),_vm._v(" "),_c('nav',[_c('router-link',{attrs:{"to":{ name: 'docs-class', params: Object.assign({}, {source: _vm.source, tag: _vm.tag}, _vm.docs) }}},[_vm._v("Reference")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'docs-file', params: Object.assign({}, {source: _vm.source, tag: _vm.tag}, _vm.tutorials) }}},[_vm._v("Guide")]),_vm._v(" "),_c('a',{attrs:{"href":("https://github.com/" + _vm.repository)}},[_vm._v("GitHub")]),_vm._v(" "),_c('a',{attrs:{"href":"https://discord.gg/8hk5wSpSsK"}},[_vm._v("FAQ")])],1)],1)],1)}
var AppNavbar_staticRenderFns = []
var AppNavbar_esExports = { render: AppNavbar_render, staticRenderFns: AppNavbar_staticRenderFns }
/* harmony default export */ var components_AppNavbar = (AppNavbar_esExports);
// CONCATENATED MODULE: ./src/components/AppNavbar.vue
function injectStyle (ssrContext) {
  __webpack_require__("4GY5")
}
var AppNavbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppNavbar___vue_template_functional__ = false
/* styles */
var AppNavbar___vue_styles__ = injectStyle
/* scopeId */
var AppNavbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AppNavbar___vue_module_identifier__ = null
var AppNavbar_Component = AppNavbar_normalizeComponent(
  AppNavbar,
  components_AppNavbar,
  AppNavbar___vue_template_functional__,
  AppNavbar___vue_styles__,
  AppNavbar___vue_scopeId__,
  AppNavbar___vue_module_identifier__
)

/* harmony default export */ var src_components_AppNavbar = (AppNavbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stats.vue





//
//
//
//
//
//
//
//

var Stats_json = function json(res) {
  return res.json();
};
var noop = function noop() {
  // Do nothing.
};
var Stats__data = {
  downloads: 'many',
  stars: 'a lot',
  contributors: 'some',
  fetching: false
};

/* harmony default export */ var Stats = ({
  name: 'stats',

  data: function data() {
    return Stats__data;
  },
  beforeMount: function beforeMount() {
    this.fetch();
  },


  methods: {
    fetch: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function () {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, _ref2, downloads, stars, contributors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.fetching) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.fetching = true;

                _context.next = 5;
                return promise_default.a.all([fetch('https://api.npmjs.org/downloads/range/2013-08-21:2100-08-21/hypixel-api-reborn').then(Stats_json, noop), fetch('https://api.github.com/repos/hypixel-api-reborn/hypixel-api-reborn').then(Stats_json, noop), fetch('https://api.github.com/repos/hypixel-api-reborn/hypixel-api-reborn/stats/contributors').then(Stats_json, noop)]);

              case 5:
                _ref = _context.sent;
                _ref2 = slicedToArray_default()(_ref, 3);
                downloads = _ref2[0];
                stars = _ref2[1];
                contributors = _ref2[2];

                if (!downloads) {
                  _context.next = 32;
                  break;
                }

                _this.downloads = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 15;
                for (_iterator = get_iterator_default()(downloads.downloads); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  item = _step.value;
                  _this.downloads += item.downloads;
                }_context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](15);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 23:
                _context.prev = 23;
                _context.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context.prev = 26;

                if (!_didIteratorError) {
                  _context.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context.finish(26);

              case 30:
                return _context.finish(23);

              case 31:
                _this.downloads = _this.downloads.toLocaleString();

              case 32:
                if (stars) _this.stars = stars.stargazers_count.toLocaleString();
                if (contributors) _this.contributors = contributors.length.toLocaleString();

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[15, 19, 23, 31], [24,, 26, 30]]);
      }))();
    })
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40e848ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
var Stats_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"stats"},[_c('li',[_vm._v(_vm._s(_vm.downloads)+" downloads")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.stars)+" stars")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.contributors)+" contributors")])])}
var Stats_staticRenderFns = []
var Stats_esExports = { render: Stats_render, staticRenderFns: Stats_staticRenderFns }
/* harmony default export */ var components_Stats = (Stats_esExports);
// CONCATENATED MODULE: ./src/components/Stats.vue
var Stats_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Stats___vue_template_functional__ = false
/* styles */
var Stats___vue_styles__ = null
/* scopeId */
var Stats___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Stats___vue_module_identifier__ = null
var Stats_Component = Stats_normalizeComponent(
  Stats,
  components_Stats,
  Stats___vue_template_functional__,
  Stats___vue_styles__,
  Stats___vue_scopeId__,
  Stats___vue_module_identifier__
)

/* harmony default export */ var src_components_Stats = (Stats_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AppFooter = ({
  name: 'footer',
  props: ['darkMode'],
  components: {
    Stats: src_components_Stats
  },

  methods: {
    toggleDarkMode: function toggleDarkMode(event) {
      this.$emit('toggleDarkMode');
      event.preventDefault();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509aa4a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
var AppFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('container',[_c('strong',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("hypixel-api-reborn")])],1),_vm._v(" "),_c('p',[_vm._v("A feature-rich Hypixel API wrapper for Node.js")]),_vm._v(" "),_c('p',[_vm._v("Website originally created by the "),_c('a',{attrs:{"href":"https://github.com/discord-akairo/website"}},[_vm._v("discord-akairo")]),_vm._v(" team")]),_vm._v(" "),_c('stats'),_vm._v(" "),_c('a',{attrs:{"href":"","id":"dark-mode-link"},on:{"click":_vm.toggleDarkMode}},[_c('em',{staticClass:"fa",class:_vm.darkMode ? 'fa-sun-o' : 'fa-moon-o'}),_vm._v("\n      Turn "+_vm._s(_vm.darkMode ? 'on' : 'off')+" the lights\n    ")])],1)],1)}
var AppFooter_staticRenderFns = []
var AppFooter_esExports = { render: AppFooter_render, staticRenderFns: AppFooter_staticRenderFns }
/* harmony default export */ var components_AppFooter = (AppFooter_esExports);
// CONCATENATED MODULE: ./src/components/AppFooter.vue
function AppFooter_injectStyle (ssrContext) {
  __webpack_require__("juZc")
}
var AppFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppFooter___vue_template_functional__ = false
/* styles */
var AppFooter___vue_styles__ = AppFooter_injectStyle
/* scopeId */
var AppFooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AppFooter___vue_module_identifier__ = null
var AppFooter_Component = AppFooter_normalizeComponent(
  AppFooter,
  components_AppFooter,
  AppFooter___vue_template_functional__,
  AppFooter___vue_styles__,
  AppFooter___vue_scopeId__,
  AppFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_AppFooter = (AppFooter_Component.exports);

// EXTERNAL MODULE: ./node_modules/konami-code-js/src/konami-code.js
var konami_code = __webpack_require__("7ljE");
var konami_code_default = /*#__PURE__*/__webpack_require__.n(konami_code);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//






var konami = null;

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    AppNavbar: src_components_AppNavbar,
    AppFooter: src_components_AppFooter
  },

  data: function data() {
    var darkMode = localStorage.getItem('dark-mode');
    return {
      darkMode: darkMode !== 'false' && darkMode !== null,
      repository: MainSource.repo,
      konami: false
    };
  },


  methods: {
    toggleDarkMode: function toggleDarkMode() {
      this.darkMode = !this.darkMode;
      localStorage.setItem('dark-mode', this.darkMode);
      if (this.darkMode) this.$el.classList.add('dark');else this.$el.classList.remove('dark');
    },
    setRepository: function setRepository(repo) {
      this.repository = repo;
    },
    poop: function poop() {
      var _this = this;

      // Create the poop
      var poop = document.createElement('div');
      poop.className = 'poop';
      poop.innerHTML = '💩';

      // Set the poop's travel time and how spinny it is
      var duration = Math.random() * 4000 + 1000;
      poop.style.transition = 'top ' + duration + 'ms linear, left ' + duration + 'ms linear';
      poop.style.animation = 'spin ' + duration / 3000 + 's infinite linear';

      // Determine the poop's initial location and final destination
      var side = Math.floor(Math.random() * 4) + 1;
      var initial = {
        top: (side === 2 || side === 4 ? Math.random() * window.innerHeight : side === 1 ? -200 : window.innerHeight + 200) + 'px',
        left: (side === 1 || side === 3 ? Math.random() * window.innerWidth : side === 4 ? -200 : window.innerWidth + 200) + 'px'
      };
      var final = {
        top: (side === 2 || side === 4 ? Math.random() * window.innerHeight : side === 1 ? window.innerHeight + 200 : -200) + 'px',
        left: (side === 1 || side === 3 ? Math.random() * window.innerWidth : side === 4 ? window.innerWidth + 200 : -200) + 'px'
      };

      // Pinpoint and relocate the poop
      assign_default()(poop.style, initial);
      window.setTimeout(function () {
        assign_default()(poop.style, final);
      }, 100);

      // Add the poop to the page and remove it when its adventure is complete
      document.body.appendChild(poop);
      window.setTimeout(function () {
        document.body.removeChild(poop);
      }, duration + 100);

      // Take another dump
      window.setTimeout(function () {
        return _this.poop();
      }, Math.random() * 10000 + 1000);
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    if (this.darkMode) this.$el.classList.add('dark');
    if (!konami) {
      konami = new konami_code_default.a(function () {
        _this2.konami = true;
        _this2.poop();
        konami.disable();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e6740a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-navbar',{attrs:{"repository":_vm.repository}}),_vm._v(" "),_c('router-view',{attrs:{"darkMode":_vm.darkMode,"konami":_vm.konami},on:{"toggleDarkMode":_vm.toggleDarkMode,"setRepository":_vm.setRepository}}),_vm._v(" "),_c('app-footer',{attrs:{"darkMode":_vm.darkMode},on:{"toggleDarkMode":_vm.toggleDarkMode}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("NALb")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Logo.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var Logo = ({
  name: 'logo',
  props: ['light', 'konami']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cce599a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
var Logo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1500","height":"149","version":"1.1","viewBox":"0 0 150 1","xmlns":"http://www.w3.org/2000/svg","xmlns:cc":"http://creativecommons.org/ns#","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:rdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"}},[_c('g',[_c('path',{attrs:{"d":"M3.00 0.81L3.00 0.81L3.00 4.56C3.00 4.82 3.21 5.03 3.46 5.03L6.27 5.03C6.52 5.03 6.73 4.82 6.73 4.56L6.73 0.81C6.73 0.56 6.52 0.35 6.27 0.35C6.01 0.35 5.80 0.56 5.80 0.81L5.80 4.09L3.93 4.09L3.93 0.81C3.93 0.56 3.72 0.35 3.46 0.35C3.21 0.35 3.00 0.56 3.00 0.81ZM6.73 10.18L6.73 10.18L6.73 6.43C6.73 6.17 6.52 5.96 6.27 5.96L3.46 5.96C3.21 5.96 3.00 6.17 3.00 6.43L3.00 10.18C3.00 10.43 3.21 10.64 3.46 10.64C3.72 10.64 3.93 10.43 3.93 10.18L3.93 6.90L5.80 6.90L5.80 10.18C5.80 10.43 6.01 10.64 6.27 10.64C6.52 10.64 6.73 10.43 6.73 10.18ZM2.06 10.18L2.06 10.18L2.06 0.81C2.06 0.56 1.85 0.35 1.60 0.35C1.33 0.35 1.12 0.56 1.12 0.81L1.12 10.18C1.12 10.43 1.33 10.64 1.60 10.64C1.85 10.64 2.06 10.43 2.06 10.18ZM7.67 0.81L7.67 0.81L7.67 10.18C7.67 10.43 7.88 10.64 8.13 10.64C8.40 10.64 8.61 10.43 8.61 10.18L8.61 0.81C8.61 0.56 8.40 0.35 8.13 0.35C7.88 0.35 7.67 0.56 7.67 0.81ZM14.07 4.07L14.07 4.07C14.28 4.42 14.70 4.45 14.91 4.09L16.81 0.90C16.94 0.66 16.87 0.38 16.65 0.25C16.44 0.11 16.14 0.18 16.00 0.41L14.49 2.97L12.98 0.41C12.85 0.18 12.56 0.11 12.35 0.25C12.11 0.38 12.04 0.66 12.18 0.90ZM18.30 0.41L18.30 0.41L15.02 5.63C14.98 5.71 14.95 5.81 14.95 5.89L14.95 10.32C14.95 10.58 15.18 10.79 15.43 10.79C15.68 10.79 15.90 10.58 15.90 10.32L15.90 6.01L19.08 0.90C19.22 0.67 19.15 0.39 18.94 0.25C18.72 0.11 18.44 0.17 18.30 0.41ZM14.03 10.32L14.03 10.32L14.03 5.88C14.03 5.78 14 5.70 13.94 5.60L10.70 0.41C10.56 0.17 10.26 0.11 10.05 0.25C9.83 0.39 9.77 0.67 9.90 0.90L13.09 6.01L13.09 10.32C13.09 10.58 13.30 10.79 13.57 10.79C13.82 10.79 14.03 10.58 14.03 10.32ZM24.30 5.03L24.30 5.03C26.18 5.03 26.18 2.23 24.30 2.23L22.65 2.23C22.04 2.23 22.04 3.16 22.65 3.16L24.30 3.16C24.95 3.16 24.95 4.10 24.30 4.10C23.94 4.10 23.31 3.99 23.31 4.56C23.31 5.12 23.94 5.03 24.30 5.03ZM21.25 10.16L21.25 10.16L21.25 1.29L24.47 1.29C27.48 1.29 27.48 5.96 24.47 5.96L22.65 5.96C22.40 5.96 22.18 6.17 22.18 6.43L22.18 10.16C22.18 10.78 23.13 10.78 23.13 10.16L23.13 6.90L24.47 6.90C28.70 6.90 28.71 0.36 24.47 0.36L20.78 0.36C20.52 0.36 20.31 0.56 20.31 0.84L20.31 10.16C20.31 10.78 21.25 10.78 21.25 10.16ZM32.05 10.18L32.05 10.18L32.05 0.81C32.05 0.56 31.84 0.35 31.58 0.35C31.32 0.35 31.11 0.56 31.11 0.81L31.11 10.18C31.11 10.43 31.32 10.64 31.58 10.64C31.84 10.64 32.05 10.43 32.05 10.18ZM30.17 10.18L30.17 10.18L30.17 0.81C30.17 0.56 29.96 0.35 29.71 0.35C29.44 0.35 29.23 0.56 29.23 0.81L29.23 10.18C29.23 10.43 29.44 10.64 29.71 10.64C29.96 10.64 30.17 10.43 30.17 10.18ZM35.81 0.88L35.81 0.88L37.28 3.42C37.45 3.71 37.90 3.71 38.07 3.42L39.54 0.88C39.84 0.35 39.05-0.11 38.75 0.42L37.69 2.27L36.61 0.42C36.30-0.11 35.52 0.35 35.81 0.88ZM39.90 10.08L39.90 10.08L38.07 6.94C37.90 6.64 37.45 6.64 37.28 6.94L35.45 10.08C35.15 10.61 35.94 11.07 36.26 10.54L37.69 8.09L39.10 10.54C39.41 11.07 40.19 10.61 39.90 10.08ZM34.15 10.49L34.15 10.49L37.10 5.38C37.20 5.22 37.18 5.05 37.09 4.91L34.50 0.41C34.19-0.11 33.40 0.35 33.70 0.87L36.18 5.14L33.35 10.02C33.04 10.54 33.82 11.02 34.15 10.49ZM40.85 0.41L40.85 0.41L38.26 4.91C38.16 5.07 38.16 5.24 38.26 5.39L41.22 10.49C41.52 11.02 42.31 10.54 42.01 10.02L39.17 5.14L41.65 0.87C41.96 0.35 41.16-0.11 40.85 0.41ZM48.61 2.23L48.61 2.23L45.64 2.23C45.37 2.23 45.16 2.42 45.16 2.69L45.16 4.56C45.16 4.82 45.37 5.03 45.64 5.03L47.74 5.03C48.01 5.03 48.22 4.82 48.22 4.56C48.22 4.30 48.01 4.09 47.74 4.09L46.10 4.09L46.10 3.15L48.61 3.15C48.87 3.15 49.08 2.94 49.08 2.69C49.08 2.42 48.87 2.23 48.61 2.23ZM47.74 5.96L47.74 5.96L45.64 5.96C45.37 5.96 45.16 6.17 45.16 6.43L45.16 8.30C45.16 8.55 45.37 8.76 45.64 8.76L48.61 8.76C48.87 8.76 49.08 8.55 49.08 8.30C49.08 8.04 48.87 7.83 48.61 7.83L46.10 7.83L46.10 6.90L47.74 6.90C48.01 6.90 48.22 6.69 48.22 6.43C48.22 6.17 48.01 5.96 47.74 5.96ZM48.61 9.70L48.61 9.70L44.24 9.70L44.24 1.29L48.61 1.29C48.87 1.29 49.08 1.08 49.08 0.81C49.08 0.56 48.87 0.35 48.61 0.35L43.76 0.35C43.51 0.35 43.30 0.56 43.30 0.81L43.30 10.18C43.30 10.43 43.51 10.64 43.76 10.64L48.61 10.64C48.87 10.64 49.08 10.43 49.08 10.18C49.08 9.91 48.87 9.70 48.61 9.70ZM56.88 9.70L56.88 9.70L51.90 9.70L51.90 0.81C51.90 0.56 51.69 0.35 51.44 0.35C51.17 0.35 50.96 0.56 50.96 0.81L50.96 10.18C50.96 10.43 51.17 10.64 51.44 10.64L56.88 10.64C57.15 10.64 57.34 10.43 57.34 10.18C57.34 9.91 57.15 9.70 56.88 9.70ZM52.84 0.81L52.84 0.81L52.84 8.30C52.84 8.55 53.05 8.76 53.30 8.76L56.88 8.76C57.15 8.76 57.34 8.55 57.34 8.30C57.34 8.04 57.15 7.83 56.88 7.83L53.77 7.83L53.77 0.81C53.77 0.56 53.56 0.35 53.30 0.35C53.05 0.35 52.84 0.56 52.84 0.81ZM65.74 7.84L65.74 7.84L67.10 7.84C67.37 7.84 67.59 7.63 67.59 7.36C67.59 7.29 67.58 7.24 67.55 7.18L66.86 5.50C66.77 5.28 66.50 5.17 66.25 5.26C66.02 5.35 65.91 5.63 66.00 5.87L66.42 6.90L65.74 6.90C65.49 6.90 65.28 7.10 65.28 7.36C65.28 7.63 65.49 7.84 65.74 7.84ZM65.06 10.26L65.06 10.26L65.30 9.72L67.56 9.72L67.79 10.26C67.89 10.51 68.17 10.61 68.40 10.53C68.64 10.42 68.74 10.15 68.66 9.91L68.32 9.10C68.26 8.92 68.08 8.76 67.87 8.76L64.97 8.76L64.97 8.76C64.81 8.76 64.62 8.89 64.54 9.06L64.20 9.91C64.11 10.15 64.22 10.42 64.46 10.53C64.71 10.61 64.97 10.50 65.06 10.26ZM63.06 10.26L63.06 10.26L66.43 1.76L69.80 10.26C69.90 10.50 70.18 10.61 70.42 10.53C70.66 10.42 70.77 10.15 70.67 9.91L66.86 0.36C66.82 0.25 66.74 0.14 66.60 0.10C66.37 0 66.09 0.11 66.00 0.36L62.17 9.91C62.09 10.15 62.22 10.42 62.44 10.53C62.68 10.61 62.94 10.50 63.06 10.26ZM76.10 5.03L76.10 5.03C77.98 5.03 77.98 2.23 76.10 2.23L74.45 2.23C73.84 2.23 73.84 3.16 74.45 3.16L76.10 3.16C76.75 3.16 76.75 4.10 76.10 4.10C75.74 4.10 75.11 3.99 75.11 4.56C75.11 5.12 75.74 5.03 76.10 5.03ZM73.05 10.16L73.05 10.16L73.05 1.29L76.27 1.29C79.28 1.29 79.28 5.96 76.27 5.96L74.45 5.96C74.20 5.96 73.98 6.17 73.98 6.43L73.98 10.16C73.98 10.78 74.93 10.78 74.93 10.16L74.93 6.90L76.27 6.90C80.50 6.90 80.51 0.36 76.27 0.36L72.58 0.36C72.32 0.36 72.11 0.56 72.11 0.84L72.11 10.16C72.11 10.78 73.05 10.78 73.05 10.16ZM83.85 10.18L83.85 10.18L83.85 0.81C83.85 0.56 83.64 0.35 83.38 0.35C83.12 0.35 82.91 0.56 82.91 0.81L82.91 10.18C82.91 10.43 83.12 10.64 83.38 10.64C83.64 10.64 83.85 10.43 83.85 10.18ZM81.97 10.18L81.97 10.18L81.97 0.81C81.97 0.56 81.76 0.35 81.51 0.35C81.24 0.35 81.03 0.56 81.03 0.81L81.03 10.18C81.03 10.43 81.24 10.64 81.51 10.64C81.76 10.64 81.97 10.43 81.97 10.18ZM90.65 4.35C89.80 4.35 89.17 5.00 89.17 5.84C89.17 6.66 89.80 7.31 90.65 7.31C91.50 7.31 92.12 6.65 92.12 5.84C92.12 5.00 91.50 4.35 90.65 4.35ZM101.51 5.03L101.51 5.03C102.28 5.03 102.93 4.42 102.93 3.64C102.93 2.93 102.37 2.21 101.51 2.21L99.85 2.21C99.23 2.21 99.23 3.15 99.85 3.15L101.51 3.15C101.78 3.15 102.00 3.35 102.00 3.63C102.00 4.17 101.49 4.10 101.05 4.10C100.30 4.10 100.32 4.98 101.05 5.03C101.21 5.04 101.39 5.03 101.51 5.03ZM102.38 9.90L102.38 9.90L100.24 6.83C99.97 6.48 99.39 6.62 99.39 7.13L99.39 10.18C99.39 10.79 100.32 10.79 100.32 10.18L100.32 8.58L101.61 10.44C101.98 10.95 102.73 10.40 102.38 9.90ZM98.45 10.18L98.45 10.18L98.45 1.29L101.67 1.29C102.30 1.29 102.87 1.54 103.29 1.96C104.73 3.42 103.73 5.96 101.67 5.96C101.32 5.96 101.04 6.37 101.32 6.73L103.91 10.44C104.24 10.95 105.01 10.40 104.66 9.90L102.49 6.79C103.05 6.65 103.56 6.34 103.96 5.94C105.98 3.86 104.54 0.35 101.67 0.35L97.99 0.35C97.73 0.35 97.51 0.56 97.51 0.81L97.51 10.18C97.51 10.79 98.45 10.79 98.45 10.18ZM111.55 2.23L111.55 2.23L108.58 2.23C108.32 2.23 108.11 2.42 108.11 2.69L108.11 4.56C108.11 4.82 108.32 5.03 108.58 5.03L110.68 5.03C110.95 5.03 111.16 4.82 111.16 4.56C111.16 4.30 110.95 4.09 110.68 4.09L109.05 4.09L109.05 3.15L111.55 3.15C111.82 3.15 112.03 2.94 112.03 2.69C112.03 2.42 111.82 2.23 111.55 2.23ZM110.68 5.96L110.68 5.96L108.58 5.96C108.32 5.96 108.11 6.17 108.11 6.43L108.11 8.30C108.11 8.55 108.32 8.76 108.58 8.76L111.55 8.76C111.82 8.76 112.03 8.55 112.03 8.30C112.03 8.04 111.82 7.83 111.55 7.83L109.05 7.83L109.05 6.90L110.68 6.90C110.95 6.90 111.16 6.69 111.16 6.43C111.16 6.17 110.95 5.96 110.68 5.96ZM111.55 9.70L111.55 9.70L107.18 9.70L107.18 1.29L111.55 1.29C111.82 1.29 112.03 1.08 112.03 0.81C112.03 0.56 111.82 0.35 111.55 0.35L106.71 0.35C106.46 0.35 106.25 0.56 106.25 0.81L106.25 10.18C106.25 10.43 106.46 10.64 106.71 10.64L111.55 10.64C111.82 10.64 112.03 10.43 112.03 10.18C112.03 9.91 111.82 9.70 111.55 9.70ZM117.89 8.78L117.89 8.78C118.30 8.78 118.65 8.62 118.90 8.37C119.80 7.49 119.20 5.96 117.89 5.96L116.26 5.96C115.64 5.96 115.64 6.89 116.26 6.89L117.89 6.89C118.19 6.89 118.38 7.08 118.38 7.36C118.38 8.29 116.90 7.39 116.90 8.30C116.90 8.88 117.56 8.78 117.89 8.78ZM116.26 3.14L116.26 3.14L117.89 3.14C118.19 3.14 118.38 3.35 118.38 3.61C118.38 4.19 117.75 4.09 117.38 4.09C116.76 4.09 116.76 5.03 117.38 5.03C117.95 5.03 118.43 5.08 118.90 4.62C119.80 3.75 119.20 2.20 117.89 2.20L116.26 2.20C115.64 2.20 115.64 3.14 116.26 3.14ZM114.84 10.19L114.84 10.19L114.84 1.26L118.06 1.26C119.35 1.26 120.37 2.32 120.37 3.61C120.37 5.08 119.25 5.25 119.80 5.84C121.03 7.10 120.22 9.72 118.08 9.72L116.26 9.72C115.64 9.72 115.64 10.67 116.26 10.67L118.08 10.67C120.69 10.67 122.22 7.64 120.74 5.49C121.14 4.90 121.31 4.24 121.31 3.58C121.31 1.82 119.98 0.31 118.06 0.31L114.37 0.31C114.11 0.31 113.90 0.53 113.90 0.78L113.90 10.19C113.90 10.81 114.84 10.81 114.84 10.19ZM133.25 3.88L133.25 3.88C132.90 2.77 132.20 1.83 131.29 1.16C130.38 0.52 129.29 0.14 128.09 0.14C120.99 0.14 120.99 10.82 128.09 10.82C129.29 10.82 130.38 10.43 131.29 9.79C132.20 9.13 132.90 8.18 133.25 7.08C133.32 6.83 133.20 6.55 132.94 6.48C132.69 6.41 132.41 6.54 132.34 6.79C132.05 7.70 131.49 8.47 130.72 9.02C129.99 9.55 129.08 9.86 128.09 9.86C122.25 9.86 122.25 1.09 128.09 1.09C129.08 1.09 129.99 1.41 130.72 1.93C131.49 2.49 132.05 3.26 132.34 4.16C132.41 4.41 132.69 4.55 132.94 4.47C133.20 4.40 133.32 4.13 133.25 3.88ZM125.20 7.17L125.20 7.17C125.50 7.69 125.92 8.12 126.42 8.43C126.92 8.71 127.50 8.88 128.09 8.88C129.02 8.88 129.86 8.50 130.48 7.87C131.07 7.25 131.45 6.41 131.45 5.47C131.45 4.54 131.07 3.70 130.48 3.08C129.86 2.46 129.02 2.09 128.09 2.09C127.50 2.09 126.92 2.24 126.42 2.53C125.92 2.83 125.50 3.26 125.20 3.78C125.06 4.02 125.15 4.31 125.37 4.44C125.61 4.56 125.89 4.48 126.01 4.24C126.24 3.88 126.55 3.57 126.91 3.36C127.26 3.15 127.65 3.04 128.09 3.04C128.76 3.04 129.36 3.32 129.78 3.75C130.23 4.19 130.49 4.80 130.49 5.47C130.49 6.16 130.23 6.78 129.78 7.21C129.36 7.66 128.76 7.92 128.09 7.92C127.65 7.92 127.25 7.80 126.91 7.59C126.55 7.39 126.24 7.07 126.01 6.71C125.89 6.47 125.61 6.40 125.37 6.52C125.15 6.66 125.06 6.93 125.20 7.17ZM139.16 5.03L139.16 5.03C139.93 5.03 140.57 4.42 140.57 3.64C140.57 2.93 140.01 2.21 139.16 2.21L137.49 2.21C136.88 2.21 136.88 3.15 137.49 3.15L139.16 3.15C139.43 3.15 139.65 3.35 139.65 3.63C139.65 4.17 139.13 4.10 138.70 4.10C137.94 4.10 137.97 4.98 138.70 5.03C138.85 5.04 139.03 5.03 139.16 5.03ZM140.03 9.90L140.03 9.90L137.89 6.83C137.62 6.48 137.03 6.62 137.03 7.13L137.03 10.18C137.03 10.79 137.97 10.79 137.97 10.18L137.97 8.58L139.26 10.44C139.62 10.95 140.38 10.40 140.03 9.90ZM136.09 10.18L136.09 10.18L136.09 1.29L139.31 1.29C139.94 1.29 140.52 1.54 140.94 1.96C142.38 3.42 141.37 5.96 139.31 5.96C138.96 5.96 138.68 6.37 138.96 6.73L141.55 10.44C141.89 10.95 142.66 10.40 142.31 9.90L140.14 6.79C140.70 6.65 141.20 6.34 141.61 5.94C143.63 3.86 142.18 0.35 139.31 0.35L135.63 0.35C135.38 0.35 135.16 0.56 135.16 0.81L135.16 10.18C135.16 10.79 136.09 10.79 136.09 10.18ZM144.82 10.18L144.82 10.18L144.82 0.81C144.82 0.56 144.62 0.36 144.35 0.36C144.10 0.36 143.89 0.56 143.89 0.81L143.89 10.18C143.89 10.43 144.10 10.65 144.35 10.65C144.62 10.65 144.82 10.43 144.82 10.18ZM152.46 10.18L152.46 10.18L152.46 0.81C152.46 0.56 152.25 0.36 151.98 0.36C151.73 0.36 151.52 0.56 151.52 0.81L151.52 10.18C151.52 10.43 151.73 10.65 151.98 10.65C152.25 10.65 152.46 10.43 152.46 10.18ZM150.68 9.91L150.68 9.91L146.61 4.09C146.47 3.86 146.16 3.81 145.96 3.98C145.82 4.06 145.77 4.20 145.77 4.35L145.77 10.18C145.77 10.43 145.96 10.64 146.22 10.64C146.48 10.64 146.69 10.43 146.69 10.18L146.69 5.84L149.91 10.44C150.07 10.65 150.35 10.71 150.57 10.57C150.77 10.40 150.82 10.12 150.68 9.91ZM145.67 1.09L145.67 1.09L149.73 6.92C149.88 7.13 150.16 7.18 150.37 7.03C150.51 6.94 150.58 6.79 150.58 6.64L150.58 0.81C150.58 0.56 150.37 0.36 150.12 0.36C149.87 0.36 149.65 0.56 149.65 0.81L149.65 5.17L146.43 0.56C146.29 0.35 145.99 0.28 145.78 0.45C145.57 0.59 145.52 0.87 145.67 1.09Z","fill":"#ffffff"}})])])}
var Logo_staticRenderFns = []
var Logo_esExports = { render: Logo_render, staticRenderFns: Logo_staticRenderFns }
/* harmony default export */ var components_Logo = (Logo_esExports);
// CONCATENATED MODULE: ./src/components/Logo.vue
var Logo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Logo___vue_template_functional__ = false
/* styles */
var Logo___vue_styles__ = null
/* scopeId */
var Logo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Logo___vue_module_identifier__ = null
var Logo_Component = Logo_normalizeComponent(
  Logo,
  components_Logo,
  Logo___vue_template_functional__,
  Logo___vue_styles__,
  Logo___vue_scopeId__,
  Logo___vue_module_identifier__
)

/* harmony default export */ var src_components_Logo = (Logo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Home = ({
  name: 'home',
  props: ['konami'],
  components: {
    Logo: src_components_Logo
  },

  mounted: function mounted() {
    this.$emit('setRepository', MainSource.repo);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9057bbca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('slide',{attrs:{"id":"jumbotron"}},[_c('logo',{attrs:{"light":true,"konami":_vm.konami,"id":"logo"}}),_vm._v(" "),_c('code',[_vm._v("npm install hypixel-api-reborn")]),_c('br')],1),_vm._v(" "),_c('section',{attrs:{"id":"info"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"full-info-item"},[_c('router-link',{staticClass:"big-ass-btn",attrs:{"to":"/docs"}},[_vm._v("Get started")]),_vm._v(" "),_c('a',{staticClass:"big-ass-btn discord",attrs:{"href":"https://discord.gg/NSEBNMM"}},[_vm._v("Discord")])],1)])],1)}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-item"},[_c('h2',[_vm._v("About")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("hypixel-api-reborn")]),_vm._v(" is a feature-rich "),_c('a',{attrs:{"href":"https://api.hypixel.net"}},[_vm._v("Hypixel API")]),_vm._v(" wrapper for Node.js. "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-item"},[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("100% Promise-based.")]),_vm._v(" "),_c('li',[_vm._v("Speedy and efficient.")]),_vm._v(" "),_c('li',[_vm._v("Rate-limit handling.")]),_vm._v(" "),_c('li',[_vm._v("Intellisense support. "),_c('a',{attrs:{"href":"https://code.visualstudio.com/docs/editor/intellisense","title":"https://code.visualstudio.com/docs/editor/intellisense"}},[_vm._v("(?)")])])])])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/pages/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("OO9I")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var components_pages_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/url/url.js
var url_url = __webpack_require__("UZ5h");
var url_default = /*#__PURE__*/__webpack_require__.n(url_url);

// CONCATENATED MODULE: ./src/util.js



// Highlights an element with highlight.js, delaying until it's loaded
function hljs(el) {
  if (window.hljs) {
    window.hljs.highlightBlock(el);
  } else {
    var attempts = 0;
    var interval = setInterval(function () {
      if (window.hljs) {
        window.hljs.highlightBlock(el);
        clearInterval(interval);
      } else {
        attempts++;
        if (attempts >= 50) clearInterval(interval);
      }
    }, 100);
  }
}

// Creates a full URL for a GitHub source view
function util_sourceURL(url, tag, path, file, line) {
  return Object(url_url["resolve"])(url, tag + '/' + path + (file ? '/' + file : '') + (line ? '#L' + line : ''));
}

// Converts a JSDoc link value to an object of link information
function parseLink(link, docs) {
  var matches = link.match(/\{@link\s+(.+?)(?:\s+(.+?))?\s*\}/i);
  if (matches) link = matches[1];
  var text = matches ? matches[2] : null;

  // Type link
  var split = link.split(/(\.|#)/);
  if (docs.links[split[0]]) {
    return {
      text: text || link,
      link: typeof_default()(docs.links[split[0]]) === 'object' ? {
        name: docs.links[split[0]].name,
        params: docs.links[split[0]].params,
        query: { scrollTo: split[1] ? '' + (split[1] === '.' ? 's-' : '') + split[2] : undefined }
      } : docs.links[split[0]]
    };
  }

  // Any link
  if (link.match(/^https?:\/\//i)) {
    return {
      text: text || link,
      link: link
    };
  }

  // Plain text
  return { text: text || link };
}

// Converts all JSDoc links to markdown links
function convertLinks(text, docs, router, route) {
  if (!text) return null;

  var regex = /\{@link\s+(.+?)(?:\s+(.+?))?\s*\}/gi;
  var match = void 0;
  var newText = '';
  var start = 0;

  while (match = regex.exec(text)) {
    // eslint-disable-line no-cond-assign
    newText += text.slice(start, match.index);

    var parsed = parseLink(match[0], docs);
    if (parsed.link) {
      var link = void 0;
      if (typeof_default()(parsed.link) === 'object') {
        if (!parsed.link.params) parsed.link.params = {};
        parsed.link.params.source = route.params.source;
        parsed.link.params.tag = route.params.tag;
        link = router.resolve(parsed.link).href;
      } else {
        link = parsed.link;
      }
      newText += '[' + parsed.text + '](' + link + ')';
    } else {
      newText += parsed.text;
    }

    start = match.index + match[0].length;
  }

  if (newText) {
    newText += text.slice(start);
    return newText;
  }

  return text;
}

// Prefixes a doc item's name with "s-" if static
function scopedName(item) {
  return '' + (item.scope === 'static' ? 's-' : '') + item.name;
}

// Makes a key for a types array/string
function typeKey(type) {
  return typeof type === 'string' ? type : type.join('-');
}

// Stupid Holder to Improve Tag Switching
var SHITS = { switching: false };
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Navbar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Navbar = ({
  name: 'docs-navbar',
  props: ['sources', 'source'],

  data: function data() {
    return {
      sourceChoice: this.source.id,
      tagChoice: null,
      tags: null,
      search: this.$route.query.q
    };
  },


  methods: {
    loadTags: function loadTags() {
      var _this = this;

      this.tags = this.source.tags;
      if (!this.tags) {
        var startSource = this.source;
        this.source.fetchTags().then(function (tags) {
          if (_this.source.id === startSource.id) _this.tags = tags;
        });
      }
    },
    updateTagChoice: function updateTagChoice() {
      if (this.tags) this.tagChoice = this.$route.params.tag || this.source.recentTag || this.source.defaultTag;
    },
    goToSearch: function goToSearch() {
      if (this.$route.name !== 'docs-search') this.$router.push({ name: 'docs-search', query: { q: this.search } });
    }
  },

  watch: {
    sourceChoice: function sourceChoice(src) {
      if (this.$route.params.source !== src) this.$router.push({ name: 'docs-source', params: { source: src } });
    },
    tagChoice: function tagChoice(tag) {
      if (tag && this.$route.params.tag !== tag) {
        SHITS.switching = true;
        this.$router.push({ name: this.$route.name, params: extends_default()({}, this.$route.params, { tag: tag }), query: this.$route.query });
      }
    },
    source: function source(_source) {
      this.sourceChoice = _source.id;
      this.tagChoice = null;
      this.loadTags();
    },
    search: function search(q) {
      if (this.$route.query.q) this.$router.replace({ name: 'docs-search', query: { q: q } });else this.$router.push({ name: 'docs-search', query: { q: q } });
    },
    $route: function $route(to) {
      if (this.tagChoice && to.params.tag && this.tagChoice !== to.params.tag) this.tagChoice = to.params.tag;
    }
  },

  created: function created() {
    this.loadTags();
  },
  mounted: function mounted() {
    this.updateTagChoice();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483ace6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Navbar.vue
var Navbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-navbar"}},[_c('container',[_vm._v("\n    View docs for\n\n    "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sourceChoice),expression:"sourceChoice"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sourceChoice=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sources),function(source){return _c('option',{domProps:{"value":source.id}},[_vm._v(_vm._s(source.name))])}),0),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"enter":_vm.updateTagChoice}},[(_vm.tags)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tagChoice),expression:"tagChoice"}],key:_vm.source.id,on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tagChoice=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.tags),function(tag){return _c('option',{domProps:{"value":tag}},[_vm._v(_vm._s(tag))])}),0):_c('loading')],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.search),expression:"search",modifiers:{"trim":true}}],attrs:{"type":"search","placeholder":"Search"},domProps:{"value":(_vm.search)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.goToSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'docs-search' }}},[_c('em',{staticClass:"fa fa-search"})])],1)],1)}
var Navbar_staticRenderFns = []
var Navbar_esExports = { render: Navbar_render, staticRenderFns: Navbar_staticRenderFns }
/* harmony default export */ var docs_Navbar = (Navbar_esExports);
// CONCATENATED MODULE: ./src/components/docs/Navbar.vue
function Navbar_injectStyle (ssrContext) {
  __webpack_require__("EFfJ")
}
var Navbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Navbar___vue_template_functional__ = false
/* styles */
var Navbar___vue_styles__ = Navbar_injectStyle
/* scopeId */
var Navbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Navbar___vue_module_identifier__ = null
var Navbar_Component = Navbar_normalizeComponent(
  Navbar,
  docs_Navbar,
  Navbar___vue_template_functional__,
  Navbar___vue_styles__,
  Navbar___vue_scopeId__,
  Navbar___vue_module_identifier__
)

/* harmony default export */ var components_docs_Navbar = (Navbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Documentation.vue

//
//
//
//
//
//
//




/* harmony default export */ var Documentation = ({
  name: 'documentation',
  props: ['darkMode'],
  components: {
    DocsNavbar: components_docs_Navbar
  },

  data: function data() {
    return {
      sources: defineProperty_default()({}, MainSource.id, MainSource),
      source: MainSource,
      tag: MainSource.defaultTag
    };
  },


  methods: {
    setSource: function setSource(id) {
      this.source = this.sources[id];
    },
    setTag: function setTag(tag) {
      this.tag = tag;
      this.source.recentTag = tag;
    },
    handleRoute: function handleRoute(route) {
      // Set the source, or redirect to a default route
      if (route.params.source && this.sources[route.params.source]) {
        this.setSource(route.params.source);
      } else {
        this.$router.replace({ name: 'docs-class', params: {
            source: MainSource.id,
            tag: MainSource.defaultTag,
            class: MainSource.defaultClass
          } });
        return;
      }

      // Set the tag, or redirect to a default route
      if (route.params.tag) {
        this.setTag(route.params.tag);
      } else {
        this.$router.replace({ name: 'docs-file', params: {
            source: this.source.id,
            tag: this.source.recentTag || this.source.defaultTag,
            category: this.source.defaultFile.category,
            file: this.source.defaultFile.id
          } });
        return;
      }

      // Redirect to a default route
      if (!route.params.file && !route.params.class && !route.params.typedef && route.name !== 'docs-search') {
        this.$router.replace({ name: 'docs-file', params: {
            source: this.source.id,
            tag: this.tag,
            category: this.source.defaultFile.category,
            file: this.source.defaultFile.id
          } });
      }
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    },
    setRepository: function setRepository(repo) {
      this.$emit('setRepository', repo);
    }
  },

  watch: {
    $route: function $route(to) {
      this.handleRoute(to);
    }
  },

  created: function created() {
    this.handleRoute(this.$route);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43f784c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Documentation.vue
var Documentation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs"}},[_c('docs-navbar',{attrs:{"sources":_vm.sources,"source":_vm.source}}),_vm._v(" "),_c('router-view',{attrs:{"source":_vm.source,"tag":_vm.tag,"darkMode":_vm.darkMode},on:{"toggleDarkMode":_vm.toggleDarkMode,"setRepository":_vm.setRepository}})],1)}
var Documentation_staticRenderFns = []
var Documentation_esExports = { render: Documentation_render, staticRenderFns: Documentation_staticRenderFns }
/* harmony default export */ var pages_Documentation = (Documentation_esExports);
// CONCATENATED MODULE: ./src/components/pages/Documentation.vue
var Documentation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Documentation___vue_template_functional__ = false
/* styles */
var Documentation___vue_styles__ = null
/* scopeId */
var Documentation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Documentation___vue_module_identifier__ = null
var Documentation_Component = Documentation_normalizeComponent(
  Documentation,
  pages_Documentation,
  Documentation___vue_template_functional__,
  Documentation___vue_styles__,
  Documentation___vue_scopeId__,
  Documentation___vue_module_identifier__
)

/* harmony default export */ var components_pages_Documentation = (Documentation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/UnknownRoute.vue
//
//
//
//
//
//

/* harmony default export */ var UnknownRoute = ({
  name: 'unknown-route',
  props: ['darkMode']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ea9dcc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/UnknownRoute.vue
var UnknownRoute_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide',{attrs:{"id":"unknown-route"}},[_c('unknown-page',{attrs:{"type":"route","darkMode":_vm.darkMode}})],1)}
var UnknownRoute_staticRenderFns = []
var UnknownRoute_esExports = { render: UnknownRoute_render, staticRenderFns: UnknownRoute_staticRenderFns }
/* harmony default export */ var pages_UnknownRoute = (UnknownRoute_esExports);
// CONCATENATED MODULE: ./src/components/pages/UnknownRoute.vue
function UnknownRoute_injectStyle (ssrContext) {
  __webpack_require__("frPy")
}
var UnknownRoute_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UnknownRoute___vue_template_functional__ = false
/* styles */
var UnknownRoute___vue_styles__ = UnknownRoute_injectStyle
/* scopeId */
var UnknownRoute___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UnknownRoute___vue_module_identifier__ = null
var UnknownRoute_Component = UnknownRoute_normalizeComponent(
  UnknownRoute,
  pages_UnknownRoute,
  UnknownRoute___vue_template_functional__,
  UnknownRoute___vue_styles__,
  UnknownRoute___vue_scopeId__,
  UnknownRoute___vue_module_identifier__
)

/* harmony default export */ var components_pages_UnknownRoute = (UnknownRoute_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Loader.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Loader = ({
  name: 'docs-loader',
  props: ['source', 'tag', 'darkMode'],

  data: function data() {
    return {
      docs: null,
      error: null,
      loadingTag: null
    };
  },


  methods: {
    loadDocs: function loadDocs() {
      var _this = this;

      if (this.loadingTag === this.tag) return;
      this.docs = null;
      this.error = null;

      var startSource = this.source;
      var startTag = this.tag;
      this.loadingTag = this.tag;
      this.setRepository(this.source.repo);

      this.source.fetchDocs(this.tag).then(function (docs) {
        // eslint-disable-line complexity
        if (_this.source !== startSource || _this.tag !== startTag) return;
        console.log('Loading', startSource, startTag);

        // Sort everything
        docs.classes.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        docs.typedefs.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(docs.classes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            if (c.props) c.props.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            if (c.methods) c.methods.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            if (c.events) c.events.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
          }

          // Built-in type links
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        docs.links = {
          string: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String',
          number: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number',
          boolean: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean',
          symbol: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol',
          void: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined',
          Object: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object',
          Function: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function',
          function: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function',
          Array: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array',
          Set: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set',
          Map: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map',
          Date: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date',
          RegExp: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp',
          Promise: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise',
          Error: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error',
          EventEmitter: 'https://nodejs.org/dist/latest/docs/api/events.html#events_class_eventemitter',
          Timeout: 'https://nodejs.org/dist/latest/docs/api/timers.html#timers_class_timeout',
          Buffer: 'https://nodejs.org/dist/latest/docs/api/buffer.html#buffer_class_buffer',
          ReadableStream: 'https://nodejs.org/dist/latest/docs/api/stream.html#stream_class_stream_readable',
          ChildProcess: 'https://nodejs.org/dist/latest/docs/api/child_process.html#child_process_class_childprocess',
          Worker: 'https://nodejs.org/api/worker_threads.html#worker_threads_class_worker',
          MessagePort: 'https://nodejs.org/api/worker_threads.html#worker_threads_class_messageport'
        };

        // Add links for everything
        docs.externals = docs.externals || [];
        docs.classes = docs.classes || [];
        docs.typedefs = docs.typedefs || [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(docs.externals), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var x = _step2.value;
            docs.links[x.name] = x.see[0].replace(/\{@link\s+(.+?)\s*\}/i, '$1');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(docs.classes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _c = _step3.value;
            docs.links[_c.name] = { name: 'docs-class', params: { class: _c.name } };
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(docs.typedefs), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var t = _step4.value;
            docs.links[t.name] = { name: 'docs-typedef', params: { typedef: t.name } };
          } // Workaround for the single use of inter-source see also linking
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        if (_this.source.id === 'commando') {
          docs.links.Message = { name: 'docs-class', params: { source: 'main', tag: 'master', class: 'Message' } };
        }

        docs.global = _this.source.global;
        docs.source = _this.source.source;
        docs.tag = _this.tag;
        _this.docs = docs;
        _this.loadingTag = null;
        console.log('Finished loading', startSource, startTag);

        // Verify the destination item exists when switching tags
        if (SHITS.switching) {
          var route = _this.$route;
          SHITS.switching = false;
          if (route.name === 'docs-class') {
            if (!docs.classes.some(function (c) {
              return c.name === route.params.class;
            })) _this.goHome();
          } else if (route.name === 'docs-typedef') {
            if (!docs.typedefs.some(function (t) {
              return t.name === route.params.typedef;
            })) _this.goHome();
          } else if (route.name === 'docs-file') {
            if (!docs.custom[route.params.category] || !docs.custom[route.params.category].files[route.params.file]) {
              _this.goHome();
            }
          }
        }
      }).catch(function (err) {
        console.error('Error while loading', startSource, startTag, err);
        _this.error = err;
        _this.loadingTag = null;
      });
    },
    scroll: function scroll(fromRoute) {
      var _this2 = this;

      if (this.$route.query.scrollTo && this.docs) {
        var scroll = function scroll() {
          var el = document.getElementById('doc-for-' + _this2.$route.query.scrollTo);
          // For backwards-compatibility of old event URLs
          if (!el) el = document.getElementById('doc-for-e-' + _this2.$route.query.scrollTo);
          if (!el) el = document.getElementById(_this2.$route.query.scrollTo);
          if (!el) return;
          el.setAttribute('data-scrolled', true);
          setTimeout(function () {
            return el.setAttribute('data-scrolled', false);
          }, 1000);
          setTimeout(function () {
            return el.removeAttribute('data-scrolled');
          }, 2000);
          el.scrollIntoView();
          window.scrollBy(0, -50);
        };

        var delayScroll = fromRoute && (this.$route.name !== fromRoute.name || this.$route.params.class !== fromRoute.params.class || this.$route.params.typedef !== fromRoute.params.typedef || this.$route.params.file !== fromRoute.params.file);
        if (delayScroll) setTimeout(scroll, 400);else scroll();
      }
    },
    goHome: function goHome() {
      console.log('Redirecting to default file due to the current page not existing in the newly-loaded tag\'s docs.');
      this.$router.replace({ name: 'docs-file', params: {
          source: this.source.id,
          tag: this.tag,
          category: this.source.defaultFile.category,
          file: this.source.defaultFile.id
        } });
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    },
    setRepository: function setRepository(repo) {
      this.$emit('setRepository', repo);
    }
  },

  watch: {
    source: function source() {
      this.loadDocs();
    },
    tag: function tag() {
      this.loadDocs();
    },
    docs: function docs(to, from) {
      if (!from) setTimeout(this.scroll, 700);
    },
    $route: function $route(to, from) {
      this.scroll(from);
    }
  },

  created: function created() {
    this.loadDocs();
  },
  mounted: function mounted() {
    this.$nextTick(this.scroll);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b345a5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Loader.vue
var Loader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-body"}},[_c('transition',{attrs:{"name":"fade-resize","mode":"out-in"}},[(_vm.docs)?_c('router-view',{attrs:{"docs":_vm.docs,"darkMode":_vm.darkMode},on:{"toggleDarkMode":_vm.toggleDarkMode,"setRepository":_vm.setRepository}}):_c('slide',[(!_vm.error)?_c('loading'):_c('p',{attrs:{"id":"docs-error"}},[_vm._v("\n        Couldn't load the documentation data.\n        "),_c('pre',[_vm._v(_vm._s(_vm.error.toString()))])])],1)],1)],1)}
var Loader_staticRenderFns = []
var Loader_esExports = { render: Loader_render, staticRenderFns: Loader_staticRenderFns }
/* harmony default export */ var docs_Loader = (Loader_esExports);
// CONCATENATED MODULE: ./src/components/docs/Loader.vue
function Loader_injectStyle (ssrContext) {
  __webpack_require__("n1Fm")
}
var Loader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Loader___vue_template_functional__ = false
/* styles */
var Loader___vue_styles__ = Loader_injectStyle
/* scopeId */
var Loader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Loader___vue_module_identifier__ = null
var Loader_Component = Loader_normalizeComponent(
  Loader,
  docs_Loader,
  Loader___vue_template_functional__,
  Loader___vue_styles__,
  Loader___vue_scopeId__,
  Loader___vue_module_identifier__
)

/* harmony default export */ var components_docs_Loader = (Loader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Sidebar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Sidebar = ({
  name: 'docs-sidebar',
  props: ['docs', 'darkMode'],

  data: function data() {
    return {
      visible: false,
      showPrivate: false
    };
  },


  computed: {
    showTutorialsSidebar: function showTutorialsSidebar() {
      // eslint-disable-next-line eqeqeq
      return this.$route.params.category != null;
    },
    togglePrivateLabel: function togglePrivateLabel() {
      return 'Private items are ' + (this.showPrivate ? 'shown' : 'hidden') + '. Click to toggle.';
    },
    toggleDarkModeLabel: function toggleDarkModeLabel() {
      return 'The lights are ' + (this.darkMode ? 'off' : 'on') + '. Click to toggle.';
    }
  },

  methods: {
    toggle: function toggle() {
      this.visible = !this.visible;
    },
    togglePrivate: function togglePrivate() {
      this.showPrivate = !this.showPrivate;
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    }
  },

  watch: {
    showPrivate: function showPrivate(to) {
      this.$emit('showPrivate', to);
    },
    $route: function $route(to) {
      if (this.visible) this.visible = false;
      if (!to.query.scrollTo && (window.pageYOffset || document.documentElement.scrollTop) > 300) {
        window.scrollTo(0, 90);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70fc1e78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Sidebar.vue
var Sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-sidebar"}},[_c('div',{attrs:{"id":"open-btn"},on:{"click":_vm.toggle}},[_c('em',{staticClass:"fa fa-bars"})]),_vm._v(" "),_c('div',{class:_vm.visible ? 'open' : 'closed',attrs:{"id":"docs-sidebar-content"}},[_c('div',{attrs:{"id":"close-btn"},on:{"click":_vm.toggle}},[_c('em',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.showTutorialsSidebar)?void 0:_c('em',{staticClass:"fa toggle",class:_vm.showPrivate ? 'fa-eye' : 'fa-eye-slash',attrs:{"id":"docs-visibility","title":_vm.togglePrivateLabel},on:{"click":_vm.togglePrivate}}),_vm._v(" "),_c('em',{staticClass:"fa toggle",class:_vm.darkMode ? 'fa-moon-o' : 'fa-sun-o',attrs:{"id":"docs-brightness","title":_vm.toggleDarkModeLabel},on:{"click":_vm.toggleDarkMode}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[(_vm.showTutorialsSidebar)?_c('ul',_vm._l((_vm.docs.custom),function(category,categoryID){return _c('li',{key:categoryID},[_vm._v("\n          "+_vm._s(category.name)+"\n          "),_c('ul',_vm._l((category.files),function(file,fileID){return _c('li',{key:fileID},[_c('router-link',{attrs:{"to":{ name: 'docs-file', params: { category: categoryID, file: fileID } }}},[_vm._v("\n                "+_vm._s(file.name)+"\n              ")])],1)}),0)])}),0):_c('ul',{key:"docs-sidebar"},[_c('li',[_vm._v("\n          Classes\n          "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.docs.classes),function(clarse){return (_vm.showPrivate || clarse.access !== 'private')?_c('li',{key:clarse.name,staticClass:"animated-list-item"},[_c('router-link',{attrs:{"exact":"","to":{ name: 'docs-class', params: { class: clarse.name } }}},[_vm._v("\n                "+_vm._s(clarse.name)+"\n              ")])],1):_vm._e()}),0)],1),_vm._v(" "),_c('li',[_vm._v("\n          Typedefs\n          "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.docs.typedefs),function(typedef){return (_vm.showPrivate || typedef.access !== 'private')?_c('li',{key:typedef.name,staticClass:"animated-list-item"},[_c('router-link',{attrs:{"exact":"","to":{ name: 'docs-typedef', params: { typedef: typedef.name } }}},[_vm._v("\n                "+_vm._s(typedef.name)+"\n              ")])],1):_vm._e()}),0)],1)])])],2)])}
var Sidebar_staticRenderFns = []
var Sidebar_esExports = { render: Sidebar_render, staticRenderFns: Sidebar_staticRenderFns }
/* harmony default export */ var docs_Sidebar = (Sidebar_esExports);
// CONCATENATED MODULE: ./src/components/docs/Sidebar.vue
function Sidebar_injectStyle (ssrContext) {
  __webpack_require__("t5H2")
}
var Sidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sidebar___vue_template_functional__ = false
/* styles */
var Sidebar___vue_styles__ = Sidebar_injectStyle
/* scopeId */
var Sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Sidebar___vue_module_identifier__ = null
var Sidebar_Component = Sidebar_normalizeComponent(
  Sidebar,
  docs_Sidebar,
  Sidebar___vue_template_functional__,
  Sidebar___vue_styles__,
  Sidebar___vue_scopeId__,
  Sidebar___vue_module_identifier__
)

/* harmony default export */ var components_docs_Sidebar = (Sidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Viewer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Viewer = ({
  name: 'docs-viewer',
  props: ['docs', 'darkMode'],
  components: {
    Sidebar: components_docs_Sidebar
  },

  data: function data() {
    return {
      showPrivate: false
    };
  },


  computed: {
    key: function key() {
      var params = this.$route.params;
      if (params.file) return params.category + '/' + params.file;
      if (params.search) return 'search';
      return params.class || params.typedef;
    }
  },

  methods: {
    setShowPrivate: function setShowPrivate(show) {
      this.showPrivate = show;
    },
    scrollTop: function scrollTop() {
      window.scrollTo(0, 0);
    },
    toggleDarkMode: function toggleDarkMode() {
      this.$emit('toggleDarkMode');
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      var scroller = document.getElementById('scroll-top');
      var hideTimeout = void 0;
      var showTimeout = void 0;

      var showListener = function showListener() {
        if ((window.pageYOffset || document.documentElement.scrollTop) > 300) {
          clearTimeout(hideTimeout);
          clearTimeout(showTimeout);
          scroller.style.display = 'block';
          showTimeout = setTimeout(function () {
            scroller.style.opacity = '1';
          }, 20);
          window.removeEventListener('scroll', showListener);
          window.addEventListener('scroll', hideListener);
        }
      };

      var hideListener = function hideListener() {
        if ((window.pageYOffset || document.documentElement.scrollTop) < 300) {
          clearTimeout(hideTimeout);
          clearTimeout(showTimeout);
          scroller.style.opacity = '0';
          hideTimeout = setTimeout(function () {
            scroller.style.display = 'none';
          }, 1000);
          window.removeEventListener('scroll', hideListener);
          window.addEventListener('scroll', showListener);
        }
      };

      window.addEventListener('scroll', showListener);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3fa886e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Viewer.vue
var Viewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs-viewer"}},[_c('container',[_c('sidebar',{attrs:{"docs":_vm.docs,"darkMode":_vm.darkMode},on:{"showPrivate":_vm.setShowPrivate,"toggleDarkMode":_vm.toggleDarkMode}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[_c('router-view',{key:_vm.key,attrs:{"docs":_vm.docs,"showPrivate":_vm.showPrivate,"darkMode":_vm.darkMode}})],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"docs-meta"}},[_c('p',[_vm._v("\n      Documentation built at "+_vm._s(new Date(_vm.docs.meta.date).toUTCString())+"."),_c('br'),_vm._v("\n      Generator: v"+_vm._s(_vm.docs.meta.generator)+"   Format: "+_vm._s(_vm.docs.meta.format)+"\n    ")])]),_vm._v(" "),_c('div',{attrs:{"id":"scroll-top","title":"Scroll to top"},on:{"click":_vm.scrollTop}},[_c('em',{staticClass:"fa fa-arrow-up"})])],1)}
var Viewer_staticRenderFns = []
var Viewer_esExports = { render: Viewer_render, staticRenderFns: Viewer_staticRenderFns }
/* harmony default export */ var docs_Viewer = (Viewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/Viewer.vue
function Viewer_injectStyle (ssrContext) {
  __webpack_require__("809j")
}
var Viewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Viewer___vue_template_functional__ = false
/* styles */
var Viewer___vue_styles__ = Viewer_injectStyle
/* scopeId */
var Viewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Viewer___vue_module_identifier__ = null
var Viewer_Component = Viewer_normalizeComponent(
  Viewer,
  docs_Viewer,
  Viewer___vue_template_functional__,
  Viewer___vue_styles__,
  Viewer___vue_scopeId__,
  Viewer___vue_module_identifier__
)

/* harmony default export */ var components_docs_Viewer = (Viewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/SourceButton.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var SourceButton = ({
  name: 'source-button',
  props: ['meta', 'path', 'docs'],

  methods: {
    sourceURL: function sourceURL(path, file, line) {
      return util_sourceURL(this.docs.source, this.docs.tag, path, file, line);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dde7b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/SourceButton.vue
var SourceButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"source-button"},[_c('a',{attrs:{"href":("" + (_vm.meta ? _vm.sourceURL(_vm.meta.path, _vm.meta.file, _vm.meta.line) : _vm.sourceURL(_vm.path))),"title":"Source"}},[_c('em',{staticClass:"fa fa-code"})])])}
var SourceButton_staticRenderFns = []
var SourceButton_esExports = { render: SourceButton_render, staticRenderFns: SourceButton_staticRenderFns }
/* harmony default export */ var docs_SourceButton = (SourceButton_esExports);
// CONCATENATED MODULE: ./src/components/docs/SourceButton.vue
function SourceButton_injectStyle (ssrContext) {
  __webpack_require__("R+Wx")
}
var SourceButton_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SourceButton___vue_template_functional__ = false
/* styles */
var SourceButton___vue_styles__ = SourceButton_injectStyle
/* scopeId */
var SourceButton___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SourceButton___vue_module_identifier__ = null
var SourceButton_Component = SourceButton_normalizeComponent(
  SourceButton,
  docs_SourceButton,
  SourceButton___vue_template_functional__,
  SourceButton___vue_styles__,
  SourceButton___vue_scopeId__,
  SourceButton___vue_module_identifier__
)

/* harmony default export */ var components_docs_SourceButton = (SourceButton_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/FileViewer.vue

//
//
//
//
//
//
//
//





/* harmony default export */ var FileViewer = ({
  name: 'file-viewer',
  props: ['docs', 'darkMode'],
  components: {
    SourceButton: components_docs_SourceButton
  },

  data: function data() {
    if (!this.docs.custom[this.$route.params.category]) return { file: null };
    return {
      file: this.docs.custom[this.$route.params.category].files[this.$route.params.file]
    };
  },


  computed: {
    html: function html() {
      var content = void 0;
      if (this.file.type === 'md') content = this.file.content;else content = '# ' + this.file.name + '\n```' + this.file.type + '\n' + this.file.content + '\n```';
      return vue_runtime_esm["a" /* default */].filter('marked')(content);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(_this.$el.querySelectorAll('pre code')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          hljs(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4734cc58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/FileViewer.vue
var FileViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file)?_c('div',{staticClass:"docs-page",attrs:{"id":"file-viewer"}},[_c('source-button',{attrs:{"path":_vm.file.path,"docs":_vm.docs}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1):_c('unknown-page',{staticClass:"docs-page",attrs:{"darkMode":_vm.darkMode}})}
var FileViewer_staticRenderFns = []
var FileViewer_esExports = { render: FileViewer_render, staticRenderFns: FileViewer_staticRenderFns }
/* harmony default export */ var docs_FileViewer = (FileViewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/FileViewer.vue
function FileViewer_injectStyle (ssrContext) {
  __webpack_require__("i34D")
}
var FileViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FileViewer___vue_template_functional__ = false
/* styles */
var FileViewer___vue_styles__ = FileViewer_injectStyle
/* scopeId */
var FileViewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FileViewer___vue_module_identifier__ = null
var FileViewer_Component = FileViewer_normalizeComponent(
  FileViewer,
  docs_FileViewer,
  FileViewer___vue_template_functional__,
  FileViewer___vue_styles__,
  FileViewer___vue_scopeId__,
  FileViewer___vue_module_identifier__
)

/* harmony default export */ var components_docs_FileViewer = (FileViewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/TypeLink.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TypeLink = ({
  name: 'type-link',
  props: ['docs', 'type'],
  computed: {
    typeName: function typeName() {
      if (this.type[0] === 'function') return 'Function';
      return this.type[0];
    },
    link: function link() {
      if (this.docs.links[this.type[0]]) return this.docs.links[this.type[0]];
      return null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24731445","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/TypeLink.vue
var TypeLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"docs-type-link"},[(!_vm.link)?_c('span',{attrs:{"title":_vm.type[0] === '*' ? 'Any type' : null}},[_vm._v(_vm._s(_vm.typeName))]):(typeof _vm.link === 'object')?_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.typeName))]):_c('a',{attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.typeName))]),(_vm.type[1])?_c('span',[_vm._v(_vm._s(_vm.type[1]))]):_vm._e()],1)}
var TypeLink_staticRenderFns = []
var TypeLink_esExports = { render: TypeLink_render, staticRenderFns: TypeLink_staticRenderFns }
/* harmony default export */ var docs_TypeLink = (TypeLink_esExports);
// CONCATENATED MODULE: ./src/components/docs/TypeLink.vue
var TypeLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TypeLink___vue_template_functional__ = false
/* styles */
var TypeLink___vue_styles__ = null
/* scopeId */
var TypeLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TypeLink___vue_module_identifier__ = null
var TypeLink_Component = TypeLink_normalizeComponent(
  TypeLink,
  docs_TypeLink,
  TypeLink___vue_template_functional__,
  TypeLink___vue_styles__,
  TypeLink___vue_scopeId__,
  TypeLink___vue_module_identifier__
)

/* harmony default export */ var components_docs_TypeLink = (TypeLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Types.vue
//
//
//
//
//
//
//




/* harmony default export */ var Types = ({
  name: 'types',
  props: ['names', 'variable', 'nullable', 'docs'],
  components: {
    TypeLink: components_docs_TypeLink
  },

  methods: {
    typeKey: typeKey
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a0570eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Types.vue
var Types_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"docs-type"},[_vm._v("\n  "+_vm._s(_vm.nullable ? '?' : '')+_vm._s(_vm.variable ? '...' : '')),_vm._l((_vm.names),function(type){return _c('type-link',{key:_vm.typeKey(type),attrs:{"type":type,"docs":_vm.docs}})})],2)}
var Types_staticRenderFns = []
var Types_esExports = { render: Types_render, staticRenderFns: Types_staticRenderFns }
/* harmony default export */ var docs_Types = (Types_esExports);
// CONCATENATED MODULE: ./src/components/docs/Types.vue
function Types_injectStyle (ssrContext) {
  __webpack_require__("/Muf")
}
var Types_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Types___vue_template_functional__ = false
/* styles */
var Types___vue_styles__ = Types_injectStyle
/* scopeId */
var Types___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Types___vue_module_identifier__ = null
var Types_Component = Types_normalizeComponent(
  Types,
  docs_Types,
  Types___vue_template_functional__,
  Types___vue_styles__,
  Types___vue_scopeId__,
  Types___vue_module_identifier__
)

/* harmony default export */ var components_docs_Types = (Types_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/ParamTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ParamTable = ({
  name: 'param-table',
  props: ['params', 'docs'],
  components: {
    Types: components_docs_Types
  },

  computed: {
    hasOptional: function hasOptional() {
      return this.params.some(function (p) {
        return p.optional;
      });
    }
  },

  methods: {
    typeKey: typeKey,

    paramDescription: function paramDescription(param) {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(param.description, this.docs, this.$router, this.$route));
    },
    paramDefault: function paramDefault(param) {
      return param.optional ? '<code>' + param.default + '</code>' : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3d8541e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/ParamTable.vue
var ParamTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"param-table-wrapper"},[_c('table',{staticClass:"param-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Parameter")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),(_vm.hasOptional)?_c('th',[_vm._v("Optional")]):_vm._e(),_vm._v(" "),(_vm.hasOptional)?_c('th',[_vm._v("Default")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Description")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.params),function(param){return _c('tr',[_c('td',[_vm._v(_vm._s(param.name))]),_vm._v(" "),_c('td',_vm._l((param.type),function(type){return _c('types',{key:_vm.typeKey(type),attrs:{"names":type,"variable":param.variable,"nullable":param.nullable,"docs":_vm.docs}})}),1),_vm._v(" "),(_vm.hasOptional)?_c('td',[(param.optional)?_c('em',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasOptional)?_c('td',[(param.optional && typeof param.default === 'undefined')?_c('em',[_vm._v("none")]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.paramDefault(param))}})]):_vm._e(),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.paramDescription(param))}})])}),0)])])}
var ParamTable_staticRenderFns = []
var ParamTable_esExports = { render: ParamTable_render, staticRenderFns: ParamTable_staticRenderFns }
/* harmony default export */ var class_viewer_ParamTable = (ParamTable_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/ParamTable.vue
function ParamTable_injectStyle (ssrContext) {
  __webpack_require__("KxB8")
}
var ParamTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ParamTable___vue_template_functional__ = false
/* styles */
var ParamTable___vue_styles__ = ParamTable_injectStyle
/* scopeId */
var ParamTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ParamTable___vue_module_identifier__ = null
var ParamTable_Component = ParamTable_normalizeComponent(
  ParamTable,
  class_viewer_ParamTable,
  ParamTable___vue_template_functional__,
  ParamTable___vue_styles__,
  ParamTable___vue_scopeId__,
  ParamTable___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_ParamTable = (ParamTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Overview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Overview = ({
  name: 'class-overview',
  props: ['properties', 'methods', 'events'],

  methods: {
    scopedName: scopedName,

    scroll: function scroll(to) {
      var el = document.getElementById('doc-for-' + to);
      el.setAttribute('data-scrolled', true);
      setTimeout(function () {
        return el.setAttribute('data-scrolled', false);
      }, 1000);
      setTimeout(function () {
        return el.removeAttribute('data-scrolled');
      }, 2000);
      el.scrollIntoView();
      window.scrollBy(0, -50);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553cd274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Overview.vue
var Overview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"class-overview"}},[(_vm.properties && _vm.properties.length > 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"title"},[_vm._v("Properties")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.properties),function(property){return _c('li',{key:_vm.scopedName(property),staticClass:"animated-list-item",on:{"click":function($event){_vm.scroll(_vm.scopedName(property))}}},[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scopedName(property) } }}},[_vm._v("\n          "+_vm._s(property.name)+"\n          "),(property.scope === 'static')?_c('span',{staticClass:"small-badge"},[_vm._v("S")]):_vm._e(),_vm._v(" "),(property.abstract)?_c('span',{staticClass:"small-badge"},[_vm._v("A")]):_vm._e(),_vm._v(" "),(property.deprecated)?_c('span',{staticClass:"small-badge warn"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(property.access === 'private')?_c('span',{staticClass:"small-badge warn"},[_vm._v("P")]):_vm._e()])],1)}),0)],1):_vm._e(),_vm._v(" "),(_vm.methods && _vm.methods.length > 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"title"},[_vm._v("Methods")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.methods),function(method){return _c('li',{key:_vm.scopedName(method),staticClass:"animated-list-item",on:{"click":function($event){_vm.scroll(_vm.scopedName(method))}}},[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scopedName(method) } }}},[_vm._v("\n          "+_vm._s(method.name)+"\n          "),(method.scope === 'static')?_c('span',{staticClass:"small-badge"},[_vm._v("S")]):_vm._e(),_vm._v(" "),(method.abstract)?_c('span',{staticClass:"small-badge"},[_vm._v("A")]):_vm._e(),_vm._v(" "),(method.deprecated)?_c('span',{staticClass:"small-badge warn"},[_vm._v("D")]):_vm._e(),_vm._v(" "),(method.access === 'private')?_c('span',{staticClass:"small-badge warn"},[_vm._v("P")]):_vm._e()])],1)}),0)],1):_vm._e(),_vm._v(" "),(_vm.events && _vm.events.length > 0)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"title"},[_vm._v("Events")]),_vm._v(" "),_c('ul',_vm._l((_vm.events),function(event){return _c('li',{on:{"click":function($event){return _vm.scroll(("e-" + (event.name)))}}},[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: ("e-" + (event.name)) } }}},[_vm._v("\n          "+_vm._s(event.name)+"\n          "),(event.deprecated)?_c('span',{staticClass:"small-badge warn"},[_vm._v("D")]):_vm._e()])],1)}),0)]):_vm._e()])}
var Overview_staticRenderFns = []
var Overview_esExports = { render: Overview_render, staticRenderFns: Overview_staticRenderFns }
/* harmony default export */ var class_viewer_Overview = (Overview_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Overview.vue
function Overview_injectStyle (ssrContext) {
  __webpack_require__("SQv5")
}
var Overview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Overview___vue_template_functional__ = false
/* styles */
var Overview___vue_styles__ = Overview_injectStyle
/* scopeId */
var Overview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Overview___vue_module_identifier__ = null
var Overview_Component = Overview_normalizeComponent(
  Overview,
  class_viewer_Overview,
  Overview___vue_template_functional__,
  Overview___vue_styles__,
  Overview___vue_scopeId__,
  Overview___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Overview = (Overview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/See.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var See = ({
  name: 'docs-see',
  props: ['see', 'docs'],

  computed: {
    parsed: function parsed() {
      var parsed = new Array(this.see.length);
      for (var s = 0; s < this.see.length; s++) {
        parsed[s] = parseLink(this.see[s], this.docs);
      }return parsed;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c22bf02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/See.vue
var See_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"docs-see"},[_vm._v("\n  See also:\n\n  "),(_vm.see.length > 1)?_c('ul',_vm._l((_vm.parsed),function(s){return _c('li',[(typeof s.link === 'object')?_c('router-link',{staticClass:"docs-type",attrs:{"to":s.link}},[_vm._v(_vm._s(s.text))]):(typeof s.link === 'string')?_c('a',{attrs:{"href":s.link}},[_vm._v(_vm._s(s.text))]):_c('span',[_vm._v(_vm._s(s.text))])],1)}),0):_c('span',[(typeof _vm.parsed[0].link === 'object')?_c('router-link',{staticClass:"docs-type",attrs:{"to":_vm.parsed[0].link}},[_vm._v(_vm._s(_vm.parsed[0].text))]):(typeof _vm.parsed[0].link === 'string')?_c('a',{attrs:{"href":_vm.parsed[0].link}},[_vm._v(_vm._s(_vm.parsed[0].text))]):_c('span',[_vm._v(_vm._s(_vm.parsed[0].text))])],1)])}
var See_staticRenderFns = []
var See_esExports = { render: See_render, staticRenderFns: See_staticRenderFns }
/* harmony default export */ var docs_See = (See_esExports);
// CONCATENATED MODULE: ./src/components/docs/See.vue
function See_injectStyle (ssrContext) {
  __webpack_require__("qvys")
}
var See_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var See___vue_template_functional__ = false
/* styles */
var See___vue_styles__ = See_injectStyle
/* scopeId */
var See___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var See___vue_module_identifier__ = null
var See_Component = See_normalizeComponent(
  See,
  docs_See,
  See___vue_template_functional__,
  See___vue_styles__,
  See___vue_scopeId__,
  See___vue_module_identifier__
)

/* harmony default export */ var components_docs_See = (See_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Property.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Property = ({
  name: 'class-property',
  props: ['prop', 'docs'],
  components: {
    Types: components_docs_Types,
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  computed: {
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.prop.description, this.docs, this.$router, this.$route));
    },
    scrollTo: function scrollTo() {
      return '' + (this.prop.scope === 'static' ? 's-' : '') + this.prop.name;
    }
  },

  methods: {
    typeKey: typeKey
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea1a4c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Property.vue
var Property_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-prop class-item",attrs:{"id":("doc-for-" + _vm.scrollTo)}},[_c('source-button',{attrs:{"meta":_vm.prop.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scrollTo } }}},[_vm._v("."+_vm._s(_vm.prop.name))])],1),_vm._v(" "),(_vm.prop.scope === 'static')?_c('span',{staticClass:"badge",attrs:{"title":"This property is on the class constructor function, not instances."}},[_vm._v("Static")]):_vm._e(),_vm._v(" "),(_vm.prop.readonly)?_c('span',{staticClass:"badge",attrs:{"title":"This property cannot be modified."}},[_vm._v("Read-only")]):_vm._e(),_vm._v(" "),(_vm.prop.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This property is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.prop.access === 'private')?_c('span',{staticClass:"badge warn",attrs:{"title":"This property is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"class-item-details"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),(_vm.prop.props && _vm.prop.props.length > 0)?_c('param-table',{attrs:{"params":_vm.prop.props,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"prop-type"},[_vm._v("\n      Type:\n      "),_vm._l((_vm.prop.type),function(type){return _c('types',{key:_vm.typeKey(type),attrs:{"names":type,"nullable":_vm.prop.nullable,"docs":_vm.docs}})})],2),_vm._v(" "),(_vm.prop.default)?_c('div',{staticClass:"prop-default"},[_vm._v("\n      Default: "),_c('code',[_vm._v(_vm._s(_vm.prop.default))])]):_vm._e(),_vm._v(" "),(_vm.prop.see)?_c('see',{attrs:{"see":_vm.prop.see,"docs":_vm.docs}}):_vm._e()],1)],1)}
var Property_staticRenderFns = []
var Property_esExports = { render: Property_render, staticRenderFns: Property_staticRenderFns }
/* harmony default export */ var class_viewer_Property = (Property_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Property.vue
function Property_injectStyle (ssrContext) {
  __webpack_require__("C0Js")
}
var Property_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Property___vue_template_functional__ = false
/* styles */
var Property___vue_styles__ = Property_injectStyle
/* scopeId */
var Property___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Property___vue_module_identifier__ = null
var Property_Component = Property_normalizeComponent(
  Property,
  class_viewer_Property,
  Property___vue_template_functional__,
  Property___vue_styles__,
  Property___vue_scopeId__,
  Property___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Property = (Property_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Method.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Method = ({
  name: 'class-method',
  props: ['method', 'docs'],
  components: {
    Types: components_docs_Types,
    TypeLink: components_docs_TypeLink,
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  computed: {
    params: function params() {
      if (!this.method.params) return null;
      return this.method.params.filter(function (p) {
        return !p.name.includes('.');
      });
    },
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.method.description, this.docs, this.$router, this.$route));
    },
    emits: function emits() {
      var _this = this;

      if (!this.method.emits) return null;
      return this.method.emits.map(function (e) {
        return parseLink(e.replace(/:event/i, ''), _this.docs);
      });
    },
    scrollTo: function scrollTo() {
      return '' + (this.method.scope === 'static' ? 's-' : '') + this.method.name;
    }
  },

  methods: {
    typeKey: typeKey
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-390b9060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Method.vue
var Method_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-method class-item",attrs:{"id":("doc-for-" + _vm.scrollTo)}},[_c('source-button',{attrs:{"meta":_vm.method.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: _vm.scrollTo } }}},[_vm._v("\n\t\t\t\t."+_vm._s(_vm.method.name)+"("),_vm._l((_vm.params),function(param){return _c('span',{staticClass:"method-param",class:param.optional ? 'optional' : ''},[_vm._v(_vm._s(param.variable ? '...' : '')+_vm._s(param.name))])}),_vm._v(")\n\t\t\t")],2)],1),_vm._v(" "),(_vm.method.scope === 'static')?_c('span',{staticClass:"badge",attrs:{"title":"This method is on the class constructor function, not instances."}},[_vm._v("Static")]):_vm._e(),_vm._v(" "),(_vm.method.abstract)?_c('span',{staticClass:"badge",attrs:{"title":"This method is abstract, and must be implemented in a child class."}},[_vm._v("Abstract")]):_vm._e(),_vm._v(" "),(_vm.method.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This method is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.method.access === 'private')?_c('span',{staticClass:"badge warn",attrs:{"title":"This method is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"class-item-details"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),(_vm.method.params)?_c('param-table',{attrs:{"params":_vm.method.params,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"method-return"},[_vm._v("\n        Returns:\n        "),(_vm.method.returns)?_c('span',_vm._l((_vm.method.returns.types || _vm.method.returns),function(rtrn){return _c('types',{key:_vm.typeKey(rtrn),attrs:{"names":rtrn,"variable":_vm.method.returns.variable,"nullable":_vm.method.returns.nullable,"docs":_vm.docs}})}),1):_c('type-link',{staticClass:"docs-type",attrs:{"type":['void'],"docs":_vm.docs}}),_vm._v(" "),(_vm.method.returns && _vm.method.returns.description)?_c('p',[_vm._v(_vm._s(_vm.method.returns.description))]):_vm._e()],1),_vm._v(" "),(_vm.method.throws)?_c('div',{staticClass:"method-throws"},[_vm._v("\n        Throws:\n        "),_vm._l((_vm.method.throws),function(thrw){return _c('types',{key:thrw,attrs:{"names":thrw,"docs":_vm.docs}})})],2):_vm._e(),_vm._v(" "),(_vm.emits)?_c('div',{staticClass:"method-emits"},[_vm._v("\n        Emits:\n        "),(_vm.emits.length > 1)?_c('ul',_vm._l((_vm.emits),function(event){return _c('li',[_c('router-link',{staticClass:"docs-type",attrs:{"to":event.link}},[_vm._v(_vm._s(event.text))])],1)}),0):_c('router-link',{staticClass:"docs-type",attrs:{"to":_vm.emits[0].link}},[_vm._v(_vm._s(_vm.emits[0].text))])],1):_vm._e(),_vm._v(" "),(_vm.method.examples)?_c('div',{staticClass:"method-examples"},[_vm._v("\n\t\t\t\tExamples:\n\t\t\t\t"),_vm._l((_vm.method.examples),function(example){return _c('pre',[_c('code',{staticClass:"javascript"},[_vm._v(_vm._s(example))])])})],2):_vm._e(),_vm._v(" "),(_vm.method.see)?_c('see',{attrs:{"see":_vm.method.see,"docs":_vm.docs}}):_vm._e()],1)],1)}
var Method_staticRenderFns = []
var Method_esExports = { render: Method_render, staticRenderFns: Method_staticRenderFns }
/* harmony default export */ var class_viewer_Method = (Method_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Method.vue
function Method_injectStyle (ssrContext) {
  __webpack_require__("SVOi")
}
var Method_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Method___vue_template_functional__ = false
/* styles */
var Method___vue_styles__ = Method_injectStyle
/* scopeId */
var Method___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Method___vue_module_identifier__ = null
var Method_Component = Method_normalizeComponent(
  Method,
  class_viewer_Method,
  Method___vue_template_functional__,
  Method___vue_styles__,
  Method___vue_scopeId__,
  Method___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Method = (Method_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/Event.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Event = ({
  name: 'class-event',
  props: ['event', 'docs'],
  components: {
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  computed: {
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.event.description, this.docs, this.$router, this.$route));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-074b5f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/Event.vue
var Event_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-event class-item",attrs:{"id":("doc-for-e-" + (_vm.event.name))}},[_c('source-button',{attrs:{"meta":_vm.event.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"to":{ name: 'docs-class', query: { scrollTo: ("e-" + (_vm.event.name)) } }}},[_vm._v(_vm._s(_vm.event.name))])],1),_vm._v(" "),(_vm.event.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This event is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"class-item-details"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),(_vm.event.params && _vm.event.params.length > 0)?_c('param-table',{attrs:{"params":_vm.event.params,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),(_vm.event.see)?_c('see',{attrs:{"see":_vm.event.see,"docs":_vm.docs}}):_vm._e()],1)],1)}
var Event_staticRenderFns = []
var Event_esExports = { render: Event_render, staticRenderFns: Event_staticRenderFns }
/* harmony default export */ var class_viewer_Event = (Event_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/Event.vue
function Event_injectStyle (ssrContext) {
  __webpack_require__("pgmh")
}
var Event_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Event___vue_template_functional__ = false
/* styles */
var Event___vue_styles__ = Event_injectStyle
/* scopeId */
var Event___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Event___vue_module_identifier__ = null
var Event_Component = Event_normalizeComponent(
  Event,
  class_viewer_Event,
  Event___vue_template_functional__,
  Event___vue_styles__,
  Event___vue_scopeId__,
  Event___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_Event = (Event_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/class-viewer/ClassViewer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var ClassViewer = ({
  name: 'class-viewer',
  props: ['docs', 'showPrivate', 'darkMode'],
  components: {
    TypeLink: components_docs_TypeLink,
    ParamTable: docs_class_viewer_ParamTable,
    Overview: docs_class_viewer_Overview,
    Property: docs_class_viewer_Property,
    Method: docs_class_viewer_Method,
    Event: docs_class_viewer_Event,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  data: function data() {
    var _this = this;

    return {
      clarse: this.docs.classes.find(function (c) {
        return c.name === _this.$route.params.class;
      })
    };
  },


  computed: {
    constructorParams: function constructorParams() {
      if (!this.clarse.construct || !this.clarse.construct.params) return null;
      return this.clarse.construct.params.filter(function (p) {
        return !p.name.includes('.');
      });
    },
    properties: function properties() {
      if (!this.clarse.props) return null;
      var props = void 0;
      if (this.showPrivate) props = this.clarse.props;else props = this.clarse.props.filter(function (p) {
        return p.access !== 'private';
      });
      return props.sort(function (a, b) {
        return ('' + (a.scope === 'static' ? 'ZZZ' : '') + a.name).localeCompare('' + (b.scope === 'static' ? 'ZZZ' : '') + b.name);
      });
    },
    methods: function methods() {
      if (!this.clarse.methods) return null;
      var methods = void 0;
      if (this.showPrivate) methods = this.clarse.methods;else methods = this.clarse.methods.filter(function (p) {
        return p.access !== 'private';
      });
      return methods.sort(function (a, b) {
        return ('' + (a.scope === 'static' ? 'ZZZ' : '') + a.name).localeCompare('' + (b.scope === 'static' ? 'ZZZ' : '') + b.name);
      });
    },
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.clarse.description, this.docs, this.$router, this.$route));
    }
  },

  methods: {
    scopedName: scopedName
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(_this2.$el.querySelectorAll('pre code')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          hljs(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6defc1de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/class-viewer/ClassViewer.vue
var ClassViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clarse)?_c('div',{staticClass:"docs-page",attrs:{"id":"class-viewer"}},[_c('source-button',{attrs:{"meta":_vm.clarse.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.clarse.name))]),_vm._v(" "),_c('p',{staticClass:"class-name-extra"},[(_vm.clarse.extends)?_c('span',[_vm._v("extends "),_c('type-link',{attrs:{"type":_vm.clarse.extends,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),(_vm.clarse.implements)?_c('span',[_vm._v("implements "),_c('type-link',{attrs:{"type":_vm.clarse.implements,"docs":_vm.docs}})],1):_vm._e()]),_vm._v(" "),(_vm.clarse.abstract)?_c('span',{staticClass:"badge class-badge",attrs:{"title":"This class is abstract, and may not be instantiated itself."}},[_vm._v("Abstract")]):_vm._e(),_vm._v(" "),(_vm.clarse.deprecated)?_c('span',{staticClass:"badge class-badge warn",attrs:{"title":"This class is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.clarse.access === 'private')?_c('span',{staticClass:"badge class-badge warn",attrs:{"title":"This class is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),(_vm.clarse.description)?_c('p',{staticClass:"class-desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),(_vm.clarse.see)?_c('see',{attrs:{"see":_vm.clarse.see,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),(_vm.clarse.construct && (_vm.showPrivate || _vm.clarse.construct.access !== 'private'))?_c('div',{attrs:{"id":"class-constructor"}},[_c('h2',[_vm._v("Constructor")]),_vm._v(" "),_c('pre',[_c('code',{staticClass:"js"},[_vm._v("new "+_vm._s(_vm.docs.global)+"."+_vm._s(_vm.clarse.name)+"("),_vm._l((_vm.constructorParams),function(param){return _c('span',{staticClass:"constructor-param"},[_vm._v(_vm._s(param.name))])}),_vm._v(");")],2)]),_vm._v(" "),_c('param-table',{attrs:{"params":_vm.clarse.construct.params,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),_c('overview',{attrs:{"properties":_vm.properties,"methods":_vm.methods,"events":_vm.clarse.events}}),_vm._v(" "),(_vm.properties && _vm.properties.length > 0)?_c('h2',[_vm._v("Properties")]):_vm._e(),_vm._v(" "),_vm._l((_vm.properties),function(prop){return _c('property',{key:_vm.scopedName(prop),attrs:{"prop":prop,"docs":_vm.docs}})}),_vm._v(" "),(_vm.methods && _vm.methods.length > 0)?_c('h2',[_vm._v("Methods")]):_vm._e(),_vm._v(" "),_vm._l((_vm.methods),function(method){return _c('method',{key:_vm.scopedName(method),attrs:{"method":method,"docs":_vm.docs}})}),_vm._v(" "),(_vm.clarse.events && _vm.clarse.events.length > 0)?_c('h2',[_vm._v("Events")]):_vm._e(),_vm._v(" "),_vm._l((_vm.clarse.events),function(event){return _c('event',{key:("e-" + (event.name)),attrs:{"event":event,"docs":_vm.docs}})})],2):_c('unknown-page',{staticClass:"docs-page",attrs:{"darkMode":_vm.darkMode}})}
var ClassViewer_staticRenderFns = []
var ClassViewer_esExports = { render: ClassViewer_render, staticRenderFns: ClassViewer_staticRenderFns }
/* harmony default export */ var class_viewer_ClassViewer = (ClassViewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/class-viewer/ClassViewer.vue
function ClassViewer_injectStyle (ssrContext) {
  __webpack_require__("/RZT")
}
var ClassViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClassViewer___vue_template_functional__ = false
/* styles */
var ClassViewer___vue_styles__ = ClassViewer_injectStyle
/* scopeId */
var ClassViewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClassViewer___vue_module_identifier__ = null
var ClassViewer_Component = ClassViewer_normalizeComponent(
  ClassViewer,
  class_viewer_ClassViewer,
  ClassViewer___vue_template_functional__,
  ClassViewer___vue_styles__,
  ClassViewer___vue_scopeId__,
  ClassViewer___vue_module_identifier__
)

/* harmony default export */ var docs_class_viewer_ClassViewer = (ClassViewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/TypedefViewer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var TypedefViewer = ({
  name: 'typedef-viewer',
  props: ['docs', 'darkMode'],
  components: {
    Types: components_docs_Types,
    ParamTable: docs_class_viewer_ParamTable,
    SourceButton: components_docs_SourceButton,
    See: components_docs_See
  },

  data: function data() {
    var _this = this;

    return {
      typedef: this.docs.typedefs.find(function (t) {
        return t.name === _this.$route.params.typedef;
      })
    };
  },


  computed: {
    description: function description() {
      return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(this.typedef.description, this.docs, this.$router, this.$route));
    },
    returnsDescription: function returnsDescription() {
      var returns = this.typedef.returns;
      if (returns) return vue_runtime_esm["a" /* default */].filter('marked')(convertLinks(returns.description, this.docs, this.$router, this.$route));
      return '';
    }
  },

  methods: {
    typeKey: typeKey
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(_this2.$el.querySelectorAll('pre code')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          hljs(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b5bf344","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/TypedefViewer.vue
var TypedefViewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typedef)?_c('div',{staticClass:"docs-page",attrs:{"id":"typedef-viewer"}},[_c('source-button',{attrs:{"meta":_vm.typedef.meta,"docs":_vm.docs}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.typedef.name))]),_vm._v(" "),(_vm.typedef.deprecated)?_c('span',{staticClass:"badge warn",attrs:{"title":"This typedef is deprecated, and may be removed in a future version."}},[_vm._v("Deprecated")]):_vm._e(),_vm._v(" "),(_vm.typedef.access === 'private')?_c('span',{staticClass:"badge class-badge warn",attrs:{"title":"This typedef is private, and may change or be removed at any time."}},[_vm._v("Private")]):_vm._e(),_vm._v(" "),(_vm.typedef.description)?_c('p',{staticClass:"typedef-desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),(_vm.typedef.see)?_c('see',{attrs:{"see":_vm.typedef.see,"docs":_vm.docs}}):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("Types")]),_vm._v(" "),_c('ul',{attrs:{"id":"typedef-types"}},_vm._l((_vm.typedef.type),function(type){return _c('li',{key:_vm.typeKey(type)},[_c('types',{attrs:{"names":type,"docs":_vm.docs}})],1)}),0),_vm._v(" "),(_vm.typedef.props && _vm.typedef.props.length > 0)?_c('div',{attrs:{"id":"typedef-props"}},[_c('h2',[_vm._v("Properties")]),_vm._v(" "),_c('param-table',{attrs:{"params":_vm.typedef.props,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),(_vm.typedef.params && _vm.typedef.params.length > 0)?_c('div',{attrs:{"id":"typedef-params"}},[_c('h2',[_vm._v("Parameters")]),_vm._v(" "),_c('param-table',{attrs:{"params":_vm.typedef.params,"docs":_vm.docs}})],1):_vm._e(),_vm._v(" "),(_vm.typedef.returns)?_c('div',{attrs:{"id":"typedef-returns"}},[_c('h2',[_vm._v("Returns")]),_vm._v(" "),_c('p',{attrs:{"id":"typedef-returns-types"}},_vm._l((_vm.typedef.returns.types || _vm.typedef.returns),function(rtrn){return _c('types',{key:_vm.typeKey(rtrn),attrs:{"names":rtrn,"variable":_vm.typedef.returns.variable,"nullable":_vm.typedef.returns.nullable,"docs":_vm.docs}})}),1),_vm._v(" "),(_vm.typedef.returns.description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.returnsDescription)}}):_vm._e()]):_vm._e()],1):_c('unknown-page',{staticClass:"docs-page",attrs:{"darkMode":_vm.darkMode}})}
var TypedefViewer_staticRenderFns = []
var TypedefViewer_esExports = { render: TypedefViewer_render, staticRenderFns: TypedefViewer_staticRenderFns }
/* harmony default export */ var docs_TypedefViewer = (TypedefViewer_esExports);
// CONCATENATED MODULE: ./src/components/docs/TypedefViewer.vue
function TypedefViewer_injectStyle (ssrContext) {
  __webpack_require__("t2Up")
}
var TypedefViewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TypedefViewer___vue_template_functional__ = false
/* styles */
var TypedefViewer___vue_styles__ = TypedefViewer_injectStyle
/* scopeId */
var TypedefViewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TypedefViewer___vue_module_identifier__ = null
var TypedefViewer_Component = TypedefViewer_normalizeComponent(
  TypedefViewer,
  docs_TypedefViewer,
  TypedefViewer___vue_template_functional__,
  TypedefViewer___vue_styles__,
  TypedefViewer___vue_scopeId__,
  TypedefViewer___vue_module_identifier__
)

/* harmony default export */ var components_docs_TypedefViewer = (TypedefViewer_Component.exports);

// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__("BDm9");
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/SearchResults.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SearchResults = ({
  props: ['results', 'showScores', 'searchTerm'],

  methods: {
    highlightName: function highlightName(name) {
      return name.replace(this.searchRegex, function (match) {
        return '<strong>' + match + '</strong>';
      });
    }
  },

  computed: {
    searchRegex: function searchRegex() {
      return new RegExp(this.searchTerm, 'ig');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c2a754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/SearchResults.vue
var SearchResults_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"results-list",attrs:{"name":"animated-list","tag":"ul"}},_vm._l((_vm.results),function(result){return _c('li',{key:result.item.key || result.item.fullName || result.item.name,staticClass:"animated-list-item"},[(_vm.showScores)?_c('span',{staticClass:"score"},[_vm._v(_vm._s(Math.round((1 - result.score) * 100))+"%")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":result.item.route}},[_c('span',{staticClass:"badge",attrs:{"title":result.item.type}},[_vm._v(_vm._s(result.item.type[0]))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.highlightName(result.item.fullName || result.item.name))}}),_vm._v(_vm._s(result.item.type === 'Method' ? '()' : '')+"\n    ")])],1)}),0)}
var SearchResults_staticRenderFns = []
var SearchResults_esExports = { render: SearchResults_render, staticRenderFns: SearchResults_staticRenderFns }
/* harmony default export */ var docs_SearchResults = (SearchResults_esExports);
// CONCATENATED MODULE: ./src/components/docs/SearchResults.vue
function SearchResults_injectStyle (ssrContext) {
  __webpack_require__("PBIT")
}
var SearchResults_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchResults___vue_template_functional__ = false
/* styles */
var SearchResults___vue_styles__ = SearchResults_injectStyle
/* scopeId */
var SearchResults___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchResults___vue_module_identifier__ = null
var SearchResults_Component = SearchResults_normalizeComponent(
  SearchResults,
  docs_SearchResults,
  SearchResults___vue_template_functional__,
  SearchResults___vue_styles__,
  SearchResults___vue_scopeId__,
  SearchResults___vue_module_identifier__
)

/* harmony default export */ var components_docs_SearchResults = (SearchResults_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/docs/Search.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Search = ({
  name: 'docs-search',
  props: ['docs', 'showPrivate'],
  components: {
    SearchResults: components_docs_SearchResults
  },

  data: function data() {
    var toggles = { classes: true, props: true, methods: true, events: true, typedefs: true };
    return {
      toggles: toggles,
      search: this.$route.query.q,
      showScores: false,
      fuse: this.buildFuse(toggles)
    };
  },


  computed: {
    results: function results() {
      var results = this.fuse.search(this.search);

      // Add routes and other necessary info to all results
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var result = _step.value;

          if (result.item.type === 'Class') {
            result.item.route = {
              name: 'docs-class',
              params: { class: result.item.name }
            };
            continue;
          }
          if (result.item.type === 'Property' || result.item.type === 'Method') {
            result.item.fullName = fullName(result.item, result.item.parent);
            result.item.route = {
              name: 'docs-class',
              params: { class: result.item.parent },
              query: { scrollTo: scopedName(result.item) }
            };
            continue;
          }
          if (result.item.type === 'Event') {
            result.item.key = 'e-' + result.item.parent + '#' + result.item.name;
            result.item.fullName = fullName(result.item, result.item.parent);
            result.item.route = {
              name: 'docs-class',
              params: { class: result.item.parent },
              query: { scrollTo: 'e-' + result.item.name }
            };
            continue;
          }
          if (result.item.type === 'Typedef') {
            result.item.route = {
              name: 'docs-typedef',
              params: { typedef: result.item.name }
            };
            continue;
          }
        }

        // Remove class members where the class name is the only place a match is found
        // This avoids listing every member of a class just because the class name matched
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var r = 0;
      while (r < results.length) {
        var _result = results[r];
        if (_result.item.type === 'Property' || _result.item.type === 'Method' || _result.item.type === 'Event') {
          // Get a list of the keys that matched
          var keys = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(_result.matches), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var match = _step2.value;
              keys.push(match.key);
            } // Remove the item if only the class name matched
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (keys.length === 2 && keys.includes('parent') && keys.includes('fullName')) {
            results.splice(r, 1);
            continue;
          }
        }
        r++;
      }

      return results;
    },
    fullMatches: function fullMatches() {
      return this.results.filter(function (result) {
        return Math.round((1 - result.score) * 100) === 100;
      });
    },
    partialMatches: function partialMatches() {
      return this.results.filter(function (result) {
        return Math.round((1 - result.score) * 100) !== 100;
      });
    },
    toggleScoresLabel: function toggleScoresLabel() {
      return 'Scores are ' + (this.showScores ? 'shown' : 'hidden') + '. Click to toggle.';
    }
  },

  methods: {
    toggleScores: function toggleScores() {
      this.showScores = !this.showScores;
    },


    // Build an array of all doc items with minimal data
    buildFuse: function buildFuse(toggles) {
      var items = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.docs.classes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var c = _step3.value;

          if (!this.showPrivate && c.access === 'private') continue;

          if (toggles.classes) {
            items.push({
              type: 'Class',
              parent: c.name,
              name: c.name,
              fullName: c.name,
              scope: c.scope,
              access: c.access,
              route: null
            });
          }

          if (c.props && toggles.props) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = get_iterator_default()(c.props), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var p = _step5.value;

                if (!this.showPrivate && p.access === 'private') continue;
                items.push({
                  type: 'Property',
                  parent: c.name,
                  name: p.name,
                  fullName: fullName(p, c.name),
                  scope: p.scope,
                  access: p.access,
                  route: null
                });
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }

          if (c.methods && toggles.methods) {
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = get_iterator_default()(c.methods), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var m = _step6.value;

                if (!this.showPrivate && m.access === 'private') continue;
                items.push({
                  type: 'Method',
                  parent: c.name,
                  name: m.name,
                  fullName: fullName(m, c.name),
                  scope: m.scope,
                  access: m.access,
                  route: null
                });
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }

          if (c.events && toggles.events) {
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = get_iterator_default()(c.events), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var e = _step7.value;

                if (!this.showPrivate && e.access === 'private') continue;
                items.push({
                  type: 'Event',
                  parent: c.name,
                  name: e.name,
                  fullName: c.name + '#' + e.name,
                  scope: e.scope,
                  access: e.access,
                  key: null,
                  route: null
                });
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (toggles.typedefs) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(this.docs.typedefs), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var t = _step4.value;

            if (!this.showPrivate && t.access === 'private') continue;
            items.push({
              type: 'Typedef',
              parent: t.name,
              name: t.name,
              fullName: t.name,
              scope: t.scope,
              access: t.access,
              route: null
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }

      return new fuse_default.a(items, {
        keys: [{ name: 'name', weight: 0.5 }, { name: 'parent', weight: 0.2 }, { name: 'fullName', weight: 0.3 }],
        shouldSort: true,
        includeScore: true,
        includeMatches: true,
        threshold: 0.4,
        minMatchCharLength: 3
      });
    }
  },

  watch: {
    $route: function $route(to) {
      this.search = to.query.q;
    },
    search: function search(q) {
      if (this.$route.query.q === q) return;
      if (this.$route.query.q) this.$router.replace({ name: 'docs-search', query: { q: q } });else this.$router.push({ name: 'docs-search', query: { q: q } });
    },


    toggles: {
      deep: true,
      handler: function handler() {
        this.fuse = this.buildFuse(this.toggles);
      }
    },

    showPrivate: function showPrivate() {
      this.fuse = this.buildFuse(this.toggles);
    }
  }
});

function fullName(child, parentName) {
  return '' + (parentName + (child.scope === 'static' ? '.' : '#')) + child.name;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45840a6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Search.vue
var Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs-page",attrs:{"id":"docs-search"}},[_c('em',{class:("fa fa-bar-chart " + (!_vm.showScores ? 'disabled' : '')),attrs:{"id":"show-scores","title":_vm.toggleScoresLabel},on:{"click":_vm.toggleScores}}),_vm._v(" "),_c('h1',[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.search),expression:"search",modifiers:{"trim":true}}],attrs:{"type":"search"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{attrs:{"id":"toggles"}},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['classes']),expression:"toggles['classes']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['classes'])?_vm._i(_vm.toggles['classes'],null)>-1:(_vm.toggles['classes'])},on:{"change":function($event){var $$a=_vm.toggles['classes'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'classes', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'classes', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'classes', $$c)}}}}),_vm._v(" Classes")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['props']),expression:"toggles['props']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['props'])?_vm._i(_vm.toggles['props'],null)>-1:(_vm.toggles['props'])},on:{"change":function($event){var $$a=_vm.toggles['props'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'props', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'props', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'props', $$c)}}}}),_vm._v(" Properties")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['methods']),expression:"toggles['methods']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['methods'])?_vm._i(_vm.toggles['methods'],null)>-1:(_vm.toggles['methods'])},on:{"change":function($event){var $$a=_vm.toggles['methods'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'methods', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'methods', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'methods', $$c)}}}}),_vm._v(" Methods")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['events']),expression:"toggles['events']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['events'])?_vm._i(_vm.toggles['events'],null)>-1:(_vm.toggles['events'])},on:{"change":function($event){var $$a=_vm.toggles['events'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'events', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'events', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'events', $$c)}}}}),_vm._v(" Events")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toggles['typedefs']),expression:"toggles['typedefs']"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.toggles['typedefs'])?_vm._i(_vm.toggles['typedefs'],null)>-1:(_vm.toggles['typedefs'])},on:{"change":function($event){var $$a=_vm.toggles['typedefs'],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.toggles, 'typedefs', $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.toggles, 'typedefs', $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.toggles, 'typedefs', $$c)}}}}),_vm._v(" Typedefs")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.search && _vm.search.length >= 2)?_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.results.length)?_c('transition-group',{attrs:{"name":"fade"}},[(_vm.fullMatches.length)?_c('div',{key:"fullMatches",class:{ 'results-separator': _vm.fullMatches.length && _vm.partialMatches.length }},[_c('h2',[_vm._v("Results for \""+_vm._s(_vm.search)+"\"")]),_vm._v(" "),_c('search-results',{attrs:{"results":_vm.fullMatches,"showScores":_vm.showScores,"searchTerm":_vm.search}})],1):_vm._e(),_vm._v(" "),(_vm.partialMatches.length)?_c('div',{key:"partialMatches"},[_c('h2',[_vm._v("Similar results for \""+_vm._s(_vm.search)+"\"")]),_vm._v(" "),_c('search-results',{attrs:{"results":_vm.partialMatches,"showScores":_vm.showScores,"searchTerm":_vm.search}})],1):_vm._e()]):_c('p',[_vm._v("No results.")])],1)],1):_c('p',{key:"short"},[_vm._v("Your search query must be at least two characters.")])])],1)}
var Search_staticRenderFns = []
var Search_esExports = { render: Search_render, staticRenderFns: Search_staticRenderFns }
/* harmony default export */ var docs_Search = (Search_esExports);
// CONCATENATED MODULE: ./src/components/docs/Search.vue
function Search_injectStyle (ssrContext) {
  __webpack_require__("q4Z2")
}
var Search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Search___vue_template_functional__ = false
/* styles */
var Search___vue_styles__ = Search_injectStyle
/* scopeId */
var Search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Search___vue_module_identifier__ = null
var Search_Component = Search_normalizeComponent(
  Search,
  docs_Search,
  Search___vue_template_functional__,
  Search___vue_styles__,
  Search___vue_scopeId__,
  Search___vue_module_identifier__
)

/* harmony default export */ var components_docs_Search = (Search_Component.exports);

// CONCATENATED MODULE: ./src/router.js












vue_runtime_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  routes: [{ path: '/', name: 'home', component: components_pages_Home }, { path: '/docs', name: 'docs', component: components_pages_Documentation, children: [{ path: ':source', name: 'docs-source', component: components_docs_Loader, children: [{ path: ':tag', name: 'docs-tag', component: components_docs_Viewer, children: [{ path: 'search', name: 'docs-search', component: components_docs_Search }, { path: 'class/:class', name: 'docs-class', component: docs_class_viewer_ClassViewer }, { path: 'typedef/:typedef', name: 'docs-typedef', component: components_docs_TypedefViewer }, { path: ':category/:file', name: 'docs-file', component: components_docs_FileViewer }] }] }] },

  // Old URLs
  { path: '/!', redirect: { name: 'home' }, children: [{ path: 'docs', redirect: { name: 'docs' }, children: [{ path: 'tag/:tag', redirect: function redirect(to) {
          return {
            name: 'docs-tag',
            params: { source: 'main', tag: to.params.tag },
            query: { scrollTo: to.query.scrollto }
          };
        },
        children: [{ path: 'file/:category/:file', redirect: function redirect(to) {
            return {
              name: 'docs-file',
              params: { source: 'main', tag: to.params.tag, category: to.params.category, file: to.params.file },
              query: { scrollTo: to.query.scrollto }
            };
          }
        }, { path: 'class/:class', redirect: function redirect(to) {
            return {
              name: 'docs-class',
              params: { source: 'main', tag: to.params.tag, class: to.params.class },
              query: { scrollTo: to.query.scrollto }
            };
          }
        }, { path: 'typedef/:typedef', redirect: function redirect(to) {
            return {
              name: 'docs-typedef',
              params: { source: 'main', tag: to.params.tag, typedef: to.params.typedef },
              query: { scrollTo: to.query.scrollto }
            };
          }
        }] }] }] },

  // Catch-all
  { path: '*', component: components_pages_UnknownRoute }]
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Container.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Container = ({ name: 'container' });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13aaf031","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
var Container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._t("default")],2)}
var Container_staticRenderFns = []
var Container_esExports = { render: Container_render, staticRenderFns: Container_staticRenderFns }
/* harmony default export */ var components_Container = (Container_esExports);
// CONCATENATED MODULE: ./src/components/Container.vue
function Container_injectStyle (ssrContext) {
  __webpack_require__("Iyms")
}
var Container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Container___vue_template_functional__ = false
/* styles */
var Container___vue_styles__ = Container_injectStyle
/* scopeId */
var Container___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Container___vue_module_identifier__ = null
var Container_Component = Container_normalizeComponent(
  Container,
  components_Container,
  Container___vue_template_functional__,
  Container___vue_styles__,
  Container___vue_scopeId__,
  Container___vue_module_identifier__
)

/* harmony default export */ var src_components_Container = (Container_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Slide.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var Slide = ({ name: 'slide' });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222c5578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide.vue
var Slide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide"},[_c('container',[_vm._t("default")],2)],1)}
var Slide_staticRenderFns = []
var Slide_esExports = { render: Slide_render, staticRenderFns: Slide_staticRenderFns }
/* harmony default export */ var components_Slide = (Slide_esExports);
// CONCATENATED MODULE: ./src/components/Slide.vue
function Slide_injectStyle (ssrContext) {
  __webpack_require__("tzlZ")
}
var Slide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Slide___vue_template_functional__ = false
/* styles */
var Slide___vue_styles__ = Slide_injectStyle
/* scopeId */
var Slide___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Slide___vue_module_identifier__ = null
var Slide_Component = Slide_normalizeComponent(
  Slide,
  components_Slide,
  Slide___vue_template_functional__,
  Slide___vue_styles__,
  Slide___vue_scopeId__,
  Slide___vue_module_identifier__
)

/* harmony default export */ var src_components_Slide = (Slide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Loading = ({ name: 'loading' });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ba52d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
var Loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Loading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])}]
var Loading_esExports = { render: Loading_render, staticRenderFns: Loading_staticRenderFns }
/* harmony default export */ var components_Loading = (Loading_esExports);
// CONCATENATED MODULE: ./src/components/Loading.vue
function Loading_injectStyle (ssrContext) {
  __webpack_require__("Aw40")
}
var Loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Loading___vue_template_functional__ = false
/* styles */
var Loading___vue_styles__ = Loading_injectStyle
/* scopeId */
var Loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Loading___vue_module_identifier__ = null
var Loading_Component = Loading_normalizeComponent(
  Loading,
  components_Loading,
  Loading___vue_template_functional__,
  Loading___vue_styles__,
  Loading___vue_scopeId__,
  Loading___vue_module_identifier__
)

/* harmony default export */ var src_components_Loading = (Loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5c140a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnknownPage.vue
var UnknownPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Unknown "+_vm._s(_vm.type || 'page'))]),_vm._v(" "),_c('p',[_vm._v("This page doesn't actually exist. Oh no!")])])}
var UnknownPage_staticRenderFns = []
var UnknownPage_esExports = { render: UnknownPage_render, staticRenderFns: UnknownPage_staticRenderFns }
/* harmony default export */ var UnknownPage = (UnknownPage_esExports);
// CONCATENATED MODULE: ./src/components/UnknownPage.vue
var UnknownPage_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var UnknownPage___vue_template_functional__ = false
/* styles */
var UnknownPage___vue_styles__ = null
/* scopeId */
var UnknownPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UnknownPage___vue_module_identifier__ = null
var UnknownPage_Component = UnknownPage_normalizeComponent(
  __vue_script__,
  UnknownPage,
  UnknownPage___vue_template_functional__,
  UnknownPage___vue_styles__,
  UnknownPage___vue_scopeId__,
  UnknownPage___vue_module_identifier__
)

/* harmony default export */ var components_UnknownPage = (UnknownPage_Component.exports);

// CONCATENATED MODULE: ./src/main.js











vue_runtime_esm["a" /* default */].config.productionTip = false;

__webpack_require__("srIy");

// Register global components
vue_runtime_esm["a" /* default */].component('container', src_components_Container);
vue_runtime_esm["a" /* default */].component('slide', src_components_Slide);
vue_runtime_esm["a" /* default */].component('loading', src_components_Loading);
vue_runtime_esm["a" /* default */].component('unknown-page', components_UnknownPage);

// Register the hightlight.js directive
vue_runtime_esm["a" /* default */].directive('hljs', hljs);

// Register filters
vue_runtime_esm["a" /* default */].filter('marked', function (text) {
  if (!text) text = '**Documentation missing.**';
  text = text.replace(/<(info|warn)>([\s\S]+)<\/\1>/gi, '<div class="$1">$2</div>');
  return marked_default()(text);
});

/* eslint-disable no-new */
new vue_runtime_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "OO9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PBIT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R+Wx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SQv5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SVOi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "frPy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i34D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "juZc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n1Fm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pgmh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q4Z2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qvys":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "srIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t2Up":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5H2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tzlZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.57415532c8b2bfbb0ae5.js